"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/schema/index.ts
var schema_exports = {};
__export(schema_exports, {
  ACTIONS: () => ACTIONS,
  ARCHETYPE: () => Archetype,
  CONTAINER_TYPE: () => ContainerType,
  CSS_PROPERTIES: () => CSS_PROPERTIES,
  DATA: () => DATA,
  DISPLAY_GROUPS: () => DISPLAY_GROUPS,
  ELEMENTS: () => ELEMENTS,
  INTERACTIONS: () => INTERACTIONS,
  LAYOUT: () => LAYOUT,
  MEDIA: () => MEDIA,
  NATIVE_STATE_TYPE: () => NativeStateType,
  STYLE: () => STYLE
});
module.exports = __toCommonJS(schema_exports);

// ../../node_modules/@wix/ambassador-devcenter-v1-component-type-data/build/es/types.impl.js
var Exposure;
(function(Exposure2) {
  Exposure2["PRIVATE"] = "PRIVATE";
  Exposure2["INTERNAL"] = "INTERNAL";
  Exposure2["PUBLIC"] = "PUBLIC";
})(Exposure || (Exposure = {}));
var ComponentType;
(function(ComponentType2) {
  ComponentType2["NONE"] = "NONE";
  ComponentType2["STUDIO"] = "STUDIO";
  ComponentType2["PLATFORM"] = "PLATFORM";
  ComponentType2["WORKER"] = "WORKER";
  ComponentType2["DASHBOARD"] = "DASHBOARD";
  ComponentType2["WIDGET"] = "WIDGET";
  ComponentType2["PAGE"] = "PAGE";
  ComponentType2["DASHBOARD_PLATFORM"] = "DASHBOARD_PLATFORM";
  ComponentType2["STUDIO_WIDGET"] = "STUDIO_WIDGET";
  ComponentType2["EMBEDDED_SCRIPT"] = "EMBEDDED_SCRIPT";
  ComponentType2["EXTENSION"] = "EXTENSION";
  ComponentType2["SNIPPET_SOLUTION"] = "SNIPPET_SOLUTION";
  ComponentType2["DATA_COMPONENT"] = "DATA_COMPONENT";
  ComponentType2["WEB"] = "WEB";
  ComponentType2["DC_CONFIG"] = "DC_CONFIG";
  ComponentType2["WIDGET_OUT_OF_IFRAME"] = "WIDGET_OUT_OF_IFRAME";
  ComponentType2["PAGE_OUT_OF_IFRAME"] = "PAGE_OUT_OF_IFRAME";
  ComponentType2["STATIC_FILE"] = "STATIC_FILE";
  ComponentType2["APP_CONFIG"] = "APP_CONFIG";
  ComponentType2["MULTIPLE_DASHBOARDS"] = "MULTIPLE_DASHBOARDS";
  ComponentType2["PAYMENTS_GATEWAY"] = "PAYMENTS_GATEWAY";
  ComponentType2["CODE_PACKAGE"] = "CODE_PACKAGE";
  ComponentType2["AUTOMATION_TRIGGER"] = "AUTOMATION_TRIGGER";
  ComponentType2["INVOICES_ACTIONS"] = "INVOICES_ACTIONS";
  ComponentType2["DASHBOARD_APPLICATION"] = "DASHBOARD_APPLICATION";
  ComponentType2["CONTACT_LABELS"] = "CONTACT_LABELS";
  ComponentType2["WIDGET_PLUGIN"] = "WIDGET_PLUGIN";
  ComponentType2["CROSS_SELL"] = "CROSS_SELL";
  ComponentType2["LOCAL_DELIVERY"] = "LOCAL_DELIVERY";
  ComponentType2["PAYMENT_PROVIDER"] = "PAYMENT_PROVIDER";
  ComponentType2["ECOM_MEMBERSHIPS"] = "ECOM_MEMBERSHIPS";
  ComponentType2["ECOM_LINE_ITEMS_ENRICHER"] = "ECOM_LINE_ITEMS_ENRICHER";
  ComponentType2["ECOM_SHIPPING_RATES"] = "ECOM_SHIPPING_RATES";
  ComponentType2["SHIPPING_LABEL_CARRIER"] = "SHIPPING_LABEL_CARRIER";
  ComponentType2["RESTAURANTS_POS"] = "RESTAURANTS_POS";
  ComponentType2["FICTIONAL_SHIPPING_PROVIDER"] = "FICTIONAL_SHIPPING_PROVIDER";
  ComponentType2["ALERT_ENRICHER"] = "ALERT_ENRICHER";
  ComponentType2["DATA_EXTENSIONS"] = "DATA_EXTENSIONS";
  ComponentType2["GENERIC_HOOKS"] = "GENERIC_HOOKS";
  ComponentType2["AUTOMATIONS_ACTION_PROVIDER"] = "AUTOMATIONS_ACTION_PROVIDER";
  ComponentType2["ECOM_CATALOG"] = "ECOM_CATALOG";
  ComponentType2["BACK_OFFICE_EXTENSION_CONTAINER"] = "BACK_OFFICE_EXTENSION_CONTAINER";
  ComponentType2["BACK_OFFICE_EXTENSION"] = "BACK_OFFICE_EXTENSION";
  ComponentType2["AUTOMATIONS_TRIGGER_PROVIDER"] = "AUTOMATIONS_TRIGGER_PROVIDER";
  ComponentType2["IDENTITY_PRE_REGISTRATION"] = "IDENTITY_PRE_REGISTRATION";
  ComponentType2["PREMIUM_PRODUCTS_PATHS"] = "PREMIUM_PRODUCTS_PATHS";
  ComponentType2["ECOM_CUSTOM_SCOPE"] = "ECOM_CUSTOM_SCOPE";
  ComponentType2["GIFT_CARDS_PROVIDER"] = "GIFT_CARDS_PROVIDER";
  ComponentType2["DEALER_EXTERNAL_FILTER_PROVIDER"] = "DEALER_EXTERNAL_FILTER_PROVIDER";
  ComponentType2["ECOM_DROPSHIPPING_PROVIDER"] = "ECOM_DROPSHIPPING_PROVIDER";
  ComponentType2["INVOICES_PROVIDER"] = "INVOICES_PROVIDER";
  ComponentType2["SEO_KEYWORDS_SUGGESTIONS"] = "SEO_KEYWORDS_SUGGESTIONS";
  ComponentType2["ECOM_DISCOUNTS_TRIGGER"] = "ECOM_DISCOUNTS_TRIGGER";
  ComponentType2["MULTILINGUAL_CONTENT_PROVIDER"] = "MULTILINGUAL_CONTENT_PROVIDER";
  ComponentType2["APPLICATION_AUTOMATION"] = "APPLICATION_AUTOMATION";
  ComponentType2["BACK_OFFICE_SIDEBAR_CATEGORY"] = "BACK_OFFICE_SIDEBAR_CATEGORY";
  ComponentType2["BACK_OFFICE_PAGE"] = "BACK_OFFICE_PAGE";
  ComponentType2["ECOM_ADDITIONAL_FEES"] = "ECOM_ADDITIONAL_FEES";
  ComponentType2["PING_USER_NOTIFICATION"] = "PING_USER_NOTIFICATION";
  ComponentType2["ECOM_RECOMMENDATIONS_PROVIDER"] = "ECOM_RECOMMENDATIONS_PROVIDER";
  ComponentType2["BOOKINGS_PRICING_PROVIDER"] = "BOOKINGS_PRICING_PROVIDER";
  ComponentType2["IDENTITY_AUTHENTICATOR"] = "IDENTITY_AUTHENTICATOR";
  ComponentType2["IDENTITY_IDP_CONNECTOR"] = "IDENTITY_IDP_CONNECTOR";
  ComponentType2["ITEMS_SELECTION_PROVIDER"] = "ITEMS_SELECTION_PROVIDER";
  ComponentType2["PORTFOLIO_SYNCED_PROJECTS_PROVIDER"] = "PORTFOLIO_SYNCED_PROJECTS_PROVIDER";
  ComponentType2["COMMUNICATION_CHANNEL"] = "COMMUNICATION_CHANNEL";
  ComponentType2["IDENTITY_POST_LOGIN"] = "IDENTITY_POST_LOGIN";
  ComponentType2["BACK_OFFICE_WIDGET"] = "BACK_OFFICE_WIDGET";
  ComponentType2["SOCIAL_MARKETING_DESIGN"] = "SOCIAL_MARKETING_DESIGN";
  ComponentType2["FORMS_SUBMISSIONS_PROVIDER"] = "FORMS_SUBMISSIONS_PROVIDER";
  ComponentType2["WIX_OFFERING"] = "WIX_OFFERING";
  ComponentType2["DEV_CENTER_TESTING_COMPONENT"] = "DEV_CENTER_TESTING_COMPONENT";
  ComponentType2["COMPONENTS_VALIDATOR_PROVIDER"] = "COMPONENTS_VALIDATOR_PROVIDER";
  ComponentType2["COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER"] = "COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER";
  ComponentType2["FORMS_SCHEMA_PROVIDER"] = "FORMS_SCHEMA_PROVIDER";
  ComponentType2["BOOKINGS_EXTERNAL_CALENDAR_PROVIDER"] = "BOOKINGS_EXTERNAL_CALENDAR_PROVIDER";
  ComponentType2["ECOM_DEFAULT_TAXATION_CATEGORY"] = "ECOM_DEFAULT_TAXATION_CATEGORY";
  ComponentType2["VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER"] = "VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER";
  ComponentType2["PING_UOU_NOTIFICATION"] = "PING_UOU_NOTIFICATION";
  ComponentType2["HEADLESS_OAUTH"] = "HEADLESS_OAUTH";
  ComponentType2["ECOM_TAX_CALCULATOR_SPI"] = "ECOM_TAX_CALCULATOR_SPI";
  ComponentType2["COMMENTS_MODERATION_PROVIDER"] = "COMMENTS_MODERATION_PROVIDER";
  ComponentType2["GRID_APP_FILES_TRANSFORMER"] = "GRID_APP_FILES_TRANSFORMER";
  ComponentType2["BENEFIT_PROGRAMS_POLICY_PROVIDER"] = "BENEFIT_PROGRAMS_POLICY_PROVIDER";
  ComponentType2["PREMIUM_CUSTOM_CHARGES"] = "PREMIUM_CUSTOM_CHARGES";
  ComponentType2["ECOM_VALIDATIONS"] = "ECOM_VALIDATIONS";
  ComponentType2["COMPONENT_REFERENCE_DATA_PROVIDER"] = "COMPONENT_REFERENCE_DATA_PROVIDER";
  ComponentType2["WIX_REVIEWS_PRODUCT_CATALOG"] = "WIX_REVIEWS_PRODUCT_CATALOG";
  ComponentType2["SOCIAL_MARKETING_DESIGNS_PROVIDER"] = "SOCIAL_MARKETING_DESIGNS_PROVIDER";
  ComponentType2["GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER"] = "GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER";
  ComponentType2["COMMENTS_FILTER_PROVIDER"] = "COMMENTS_FILTER_PROVIDER";
  ComponentType2["BILLING_TAX_ID_VALIDATOR"] = "BILLING_TAX_ID_VALIDATOR";
  ComponentType2["PING_SETTINGS_GROUP"] = "PING_SETTINGS_GROUP";
  ComponentType2["FORMS_SPAM_SUBMISSIONS_PROVIDER"] = "FORMS_SPAM_SUBMISSIONS_PROVIDER";
  ComponentType2["EDITOR_ADDON"] = "EDITOR_ADDON";
  ComponentType2["EXTERNAL_DATABASE_PROVIDER"] = "EXTERNAL_DATABASE_PROVIDER";
  ComponentType2["ECOM_PAYMENT_SETTINGS"] = "ECOM_PAYMENT_SETTINGS";
  ComponentType2["NOTIFICATION_TOPIC"] = "NOTIFICATION_TOPIC";
  ComponentType2["NOTIFICATION_PREFERENCES_FILTER_PROVIDER"] = "NOTIFICATION_PREFERENCES_FILTER_PROVIDER";
  ComponentType2["BOOKINGS_RESOURCE_TYPES_PROVIDER"] = "BOOKINGS_RESOURCE_TYPES_PROVIDER";
  ComponentType2["PRICING_PLANS_FORM_CONFIGURATION"] = "PRICING_PLANS_FORM_CONFIGURATION";
  ComponentType2["USER_NOTIFICATION"] = "USER_NOTIFICATION";
  ComponentType2["CONTACT_NOTIFICATION"] = "CONTACT_NOTIFICATION";
  ComponentType2["UNIFIED_PAGE"] = "UNIFIED_PAGE";
  ComponentType2["AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER"] = "AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER";
  ComponentType2["PROPOSAL_EDITOR_PROVIDER"] = "PROPOSAL_EDITOR_PROVIDER";
  ComponentType2["CUSTOM_TABLE_RESERVATIONS_PROVIDER"] = "CUSTOM_TABLE_RESERVATIONS_PROVIDER";
  ComponentType2["COMMENTS_CONTEXT_PROVIDER"] = "COMMENTS_CONTEXT_PROVIDER";
  ComponentType2["FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER"] = "FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER";
  ComponentType2["AUTOMATIONS_VELO_ACTION_PROVIDER"] = "AUTOMATIONS_VELO_ACTION_PROVIDER";
  ComponentType2["CALENDAR_EVENT_TYPE_PROVIDER"] = "CALENDAR_EVENT_TYPE_PROVIDER";
  ComponentType2["RESERVED"] = "RESERVED";
  ComponentType2["SMS_ACTION_MESSAGE"] = "SMS_ACTION_MESSAGE";
  ComponentType2["BOOKING_POLICY_PROVIDER"] = "BOOKING_POLICY_PROVIDER";
  ComponentType2["MULTI_SERVICE_BOOKING_POLICY_PROVIDER"] = "MULTI_SERVICE_BOOKING_POLICY_PROVIDER";
  ComponentType2["AI_ASSISTANT"] = "AI_ASSISTANT";
  ComponentType2["FORMS_SUBMISSIONS_EXTENSION_PROVIDER"] = "FORMS_SUBMISSIONS_EXTENSION_PROVIDER";
  ComponentType2["MULTILINGUAL_TRANSLATION_SCHEMA"] = "MULTILINGUAL_TRANSLATION_SCHEMA";
  ComponentType2["TAX_CALCULATION_PROVIDER"] = "TAX_CALCULATION_PROVIDER";
  ComponentType2["TAX_GROUPS_PROVIDER"] = "TAX_GROUPS_PROVIDER";
  ComponentType2["BACK_OFFICE_MODAL"] = "BACK_OFFICE_MODAL";
  ComponentType2["DEPLOYMENT_PIPELINE_PROVIDER"] = "DEPLOYMENT_PIPELINE_PROVIDER";
  ComponentType2["CUSTOM_ELEMENT_WIDGET"] = "CUSTOM_ELEMENT_WIDGET";
  ComponentType2["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
  ComponentType2["BACK_OFFICE_EXTENSION_MENU_ITEM"] = "BACK_OFFICE_EXTENSION_MENU_ITEM";
  ComponentType2["FORM_TEMPLATE"] = "FORM_TEMPLATE";
  ComponentType2["NOTIFICATION_CONTENT"] = "NOTIFICATION_CONTENT";
  ComponentType2["BROADCAST_LIST"] = "BROADCAST_LIST";
  ComponentType2["PARTNERS_PAYOUTS"] = "PARTNERS_PAYOUTS";
  ComponentType2["WIX_REVIEWS_ENTITY_CATALOG"] = "WIX_REVIEWS_ENTITY_CATALOG";
  ComponentType2["VELO_PUBLISH_PIPELINE_TASK_PROVIDER"] = "VELO_PUBLISH_PIPELINE_TASK_PROVIDER";
  ComponentType2["FUNCTIONS_SHOP_PRICE_PROVIDER"] = "FUNCTIONS_SHOP_PRICE_PROVIDER";
  ComponentType2["FUNCTION"] = "FUNCTION";
  ComponentType2["ECOM_CHECKOUT_CONTENT"] = "ECOM_CHECKOUT_CONTENT";
  ComponentType2["COMMUNICATION_CHANNEL_PROVIDER"] = "COMMUNICATION_CHANNEL_PROVIDER";
  ComponentType2["WEBHOOK"] = "WEBHOOK";
  ComponentType2["TOPOLOGY"] = "TOPOLOGY";
  ComponentType2["LOYALTY_CUSTOM_REWARDS"] = "LOYALTY_CUSTOM_REWARDS";
  ComponentType2["FUNCTION_RECIPE"] = "FUNCTION_RECIPE";
  ComponentType2["BACK_OFFICE_EXTERNAL_URL"] = "BACK_OFFICE_EXTERNAL_URL";
  ComponentType2["IDENTITY_FACTOR"] = "IDENTITY_FACTOR";
  ComponentType2["ECOM_DISCOUNTS"] = "ECOM_DISCOUNTS";
  ComponentType2["VELO_CUSTOM_CSS"] = "VELO_CUSTOM_CSS";
  ComponentType2["DEALER_ADAPTIVE_COMPONENT_PROVIDER"] = "DEALER_ADAPTIVE_COMPONENT_PROVIDER";
  ComponentType2["AI_ASSISTANT_ACTION"] = "AI_ASSISTANT_ACTION";
  ComponentType2["ECOM_INVENTORY"] = "ECOM_INVENTORY";
  ComponentType2["MONITORING"] = "MONITORING";
  ComponentType2["PAPI_PROVIDER"] = "PAPI_PROVIDER";
  ComponentType2["UNIFIED_LIGHTBOX"] = "UNIFIED_LIGHTBOX";
  ComponentType2["FORMS_EXTENSION_PROVIDER"] = "FORMS_EXTENSION_PROVIDER";
  ComponentType2["MULTILINGUAL_TRANSLATION_SCHEMA_GROUP"] = "MULTILINGUAL_TRANSLATION_SCHEMA_GROUP";
  ComponentType2["PANEL"] = "PANEL";
  ComponentType2["PREMIUM_PURCHASE_VALIDATIONS"] = "PREMIUM_PURCHASE_VALIDATIONS";
  ComponentType2["BROWSER_STORAGE"] = "BROWSER_STORAGE";
  ComponentType2["SDK_DEFINITION"] = "SDK_DEFINITION";
  ComponentType2["SITE_WIDGET_SLOT"] = "SITE_WIDGET_SLOT";
  ComponentType2["CALENDAR_EVENT_VALIDATION_PROVIDER"] = "CALENDAR_EVENT_VALIDATION_PROVIDER";
  ComponentType2["CLIENT_SIDE_SERVICE"] = "CLIENT_SIDE_SERVICE";
  ComponentType2["BILLING_SETTINGS"] = "BILLING_SETTINGS";
  ComponentType2["PATTERNS_WIZARD"] = "PATTERNS_WIZARD";
  ComponentType2["APPLICATION_PROFILE"] = "APPLICATION_PROFILE";
  ComponentType2["TEXT_TO_SPEECH_ACTION_MESSAGE"] = "TEXT_TO_SPEECH_ACTION_MESSAGE";
  ComponentType2["AUDIENCE_PROVIDER"] = "AUDIENCE_PROVIDER";
  ComponentType2["PRICING_PLANS_PRICE"] = "PRICING_PLANS_PRICE";
  ComponentType2["PRICING_PLAN_START_DATE_LIMITS"] = "PRICING_PLAN_START_DATE_LIMITS";
  ComponentType2["PRICING_PLAN_START_DATE_RULES"] = "PRICING_PLAN_START_DATE_RULES";
  ComponentType2["EVENTS_TICKET_RESERVATIONS"] = "EVENTS_TICKET_RESERVATIONS";
  ComponentType2["PAYMENTS_DISPUTE_SERVICE_PLUGIN"] = "PAYMENTS_DISPUTE_SERVICE_PLUGIN";
  ComponentType2["PRICING_PLANS_FEES"] = "PRICING_PLANS_FEES";
  ComponentType2["EDITOR_REACT_COMPONENT"] = "EDITOR_REACT_COMPONENT";
  ComponentType2["SUPPLIERS_HUB_MARKETPLACE"] = "SUPPLIERS_HUB_MARKETPLACE";
  ComponentType2["FORM_SCHEMA_DYNAMIC_VALUES"] = "FORM_SCHEMA_DYNAMIC_VALUES";
  ComponentType2["BLOG_PAYWALL_PROVIDER"] = "BLOG_PAYWALL_PROVIDER";
  ComponentType2["LOYALTY_CUSTOM_REWARDS_V2"] = "LOYALTY_CUSTOM_REWARDS_V2";
  ComponentType2["STORES_PRODUCT_RESTRICTIONS"] = "STORES_PRODUCT_RESTRICTIONS";
  ComponentType2["FORM_SUBMISSION_MODERATION"] = "FORM_SUBMISSION_MODERATION";
  ComponentType2["EVENTS_EVENT_BADGES"] = "EVENTS_EVENT_BADGES";
  ComponentType2["BILLING_OPERATION"] = "BILLING_OPERATION";
  ComponentType2["BACK_OFFICE_CUSTOMIZATION"] = "BACK_OFFICE_CUSTOMIZATION";
  ComponentType2["COMPONENT_ENRICHER_PROVIDER"] = "COMPONENT_ENRICHER_PROVIDER";
  ComponentType2["BACK_OFFICE_RESTRICTED_CUSTOMIZATION"] = "BACK_OFFICE_RESTRICTED_CUSTOMIZATION";
  ComponentType2["EDITOR_APP_PREVIEWS_POC"] = "EDITOR_APP_PREVIEWS_POC";
  ComponentType2["LEGENDS_PERSONA_CONFIGURATION"] = "LEGENDS_PERSONA_CONFIGURATION";
  ComponentType2["WIX_HOSTING_APP_DEPLOYMENT_PROVIDER"] = "WIX_HOSTING_APP_DEPLOYMENT_PROVIDER";
  ComponentType2["BACKEND_WORKER"] = "BACKEND_WORKER";
  ComponentType2["EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER"] = "EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER";
  ComponentType2["WIX_HOSTING_APP_ENVIRONMENT_PROVIDER"] = "WIX_HOSTING_APP_ENVIRONMENT_PROVIDER";
  ComponentType2["SDK_EXPORTS"] = "SDK_EXPORTS";
  ComponentType2["VIEWER_SERVICE"] = "VIEWER_SERVICE";
  ComponentType2["WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN"] = "WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN";
  ComponentType2["CONTACTS_SEGMENTS_V2_FILTER_PROVIDER"] = "CONTACTS_SEGMENTS_V2_FILTER_PROVIDER";
  ComponentType2["ANALYTICS_PRODUCT_CATALOG"] = "ANALYTICS_PRODUCT_CATALOG";
  ComponentType2["SITE_MIGRATION"] = "SITE_MIGRATION";
  ComponentType2["RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN"] = "RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN";
  ComponentType2["WIX_VIBE_CODING_INSTRUCTIONS"] = "WIX_VIBE_CODING_INSTRUCTIONS";
  ComponentType2["TAX_EXEMPT_GROUPS_PROVIDER"] = "TAX_EXEMPT_GROUPS_PROVIDER";
  ComponentType2["BOOKING_AUTOMATIONS_CONFIGURATION"] = "BOOKING_AUTOMATIONS_CONFIGURATION";
  ComponentType2["WIX_VIBE_COMPONENT"] = "WIX_VIBE_COMPONENT";
  ComponentType2["WIXEL"] = "WIXEL";
  ComponentType2["STAFF_SORTING_PROVIDER"] = "STAFF_SORTING_PROVIDER";
  ComponentType2["FUNCTION_ECOM_DISCOUNT_TRIGGER_ELIGIBILITY_PROVIDER"] = "FUNCTION_ECOM_DISCOUNT_TRIGGER_ELIGIBILITY_PROVIDER";
  ComponentType2["FUNCTIONS_ASSISTANT_TOOLS"] = "FUNCTIONS_ASSISTANT_TOOLS";
  ComponentType2["SITE_MAP_INFO_PROVIDER"] = "SITE_MAP_INFO_PROVIDER";
})(ComponentType || (ComponentType = {}));
var WidgetVertical;
(function(WidgetVertical2) {
  WidgetVertical2["NONE_VERTICAL"] = "NONE_VERTICAL";
  WidgetVertical2["TOP"] = "TOP";
  WidgetVertical2["CENTER_VERTICAL"] = "CENTER_VERTICAL";
  WidgetVertical2["BOTTOM"] = "BOTTOM";
})(WidgetVertical || (WidgetVertical = {}));
var WidgetHorizontal;
(function(WidgetHorizontal2) {
  WidgetHorizontal2["NONE_HORIZONTAL"] = "NONE_HORIZONTAL";
  WidgetHorizontal2["LEFT"] = "LEFT";
  WidgetHorizontal2["CENTER_HORIZONTAL"] = "CENTER_HORIZONTAL";
  WidgetHorizontal2["RIGHT"] = "RIGHT";
})(WidgetHorizontal || (WidgetHorizontal = {}));
var WidgetWidthType;
(function(WidgetWidthType2) {
  WidgetWidthType2["NONE_TYPE"] = "NONE_TYPE";
  WidgetWidthType2["CUSTOM"] = "CUSTOM";
  WidgetWidthType2["FULL"] = "FULL";
})(WidgetWidthType || (WidgetWidthType = {}));
var Region;
(function(Region2) {
  Region2["no_region"] = "no_region";
  Region2["header"] = "header";
  Region2["pageContainer"] = "pageContainer";
  Region2["footer"] = "footer";
})(Region || (Region = {}));
var UnitType;
(function(UnitType2) {
  UnitType2["NO_UNIT"] = "NO_UNIT";
  UnitType2["AUTO"] = "AUTO";
  UnitType2["PX"] = "PX";
  UnitType2["VH"] = "VH";
  UnitType2["VW"] = "VW";
  UnitType2["PERCENTAGE"] = "PERCENTAGE";
})(UnitType || (UnitType = {}));
var HorizontalDocking;
(function(HorizontalDocking2) {
  HorizontalDocking2["NO_HDOCKING"] = "NO_HDOCKING";
  HorizontalDocking2["LEFT_DOCKING"] = "LEFT_DOCKING";
  HorizontalDocking2["HCENTER"] = "HCENTER";
  HorizontalDocking2["RIGHT_DOCKING"] = "RIGHT_DOCKING";
})(HorizontalDocking || (HorizontalDocking = {}));
var VerticalDocking;
(function(VerticalDocking2) {
  VerticalDocking2["NO_VDOCKING"] = "NO_VDOCKING";
  VerticalDocking2["TOP_DOCKING"] = "TOP_DOCKING";
  VerticalDocking2["VCENTER"] = "VCENTER";
  VerticalDocking2["BOTTOM_DOCKING"] = "BOTTOM_DOCKING";
})(VerticalDocking || (VerticalDocking = {}));
var SiteMembersSsrCaching;
(function(SiteMembersSsrCaching2) {
  SiteMembersSsrCaching2["UNKNOWN_SITE_MEMBERS_SSR_CACHING"] = "UNKNOWN_SITE_MEMBERS_SSR_CACHING";
  SiteMembersSsrCaching2["CACHING_ALLOWED"] = "CACHING_ALLOWED";
  SiteMembersSsrCaching2["CACHING_NOT_ALLOWED"] = "CACHING_NOT_ALLOWED";
})(SiteMembersSsrCaching || (SiteMembersSsrCaching = {}));
var ReplacementType;
(function(ReplacementType2) {
  ReplacementType2["UNKNOWN_REPLACEMENT"] = "UNKNOWN_REPLACEMENT";
  ReplacementType2["REPLACING"] = "REPLACING";
  ReplacementType2["REPLACEABLE"] = "REPLACEABLE";
})(ReplacementType || (ReplacementType = {}));
var PluginInterface;
(function(PluginInterface2) {
  PluginInterface2["NONE_INTERFACE"] = "NONE_INTERFACE";
  PluginInterface2["REVIEWS"] = "REVIEWS";
  PluginInterface2["RATINGS_SUMMARY"] = "RATINGS_SUMMARY";
  PluginInterface2["RATINGS_SUMMARY_OOI_LIST"] = "RATINGS_SUMMARY_OOI_LIST";
  PluginInterface2["BOOKINGS_SERVICE"] = "BOOKINGS_SERVICE";
  PluginInterface2["BOOKINGS_FORM"] = "BOOKINGS_FORM";
  PluginInterface2["BASE"] = "BASE";
  PluginInterface2["EVENT"] = "EVENT";
  PluginInterface2["PRODUCT"] = "PRODUCT";
  PluginInterface2["CHECKOUT"] = "CHECKOUT";
  PluginInterface2["CATEGORY"] = "CATEGORY";
  PluginInterface2["BOOKINGS_CALENDAR"] = "BOOKINGS_CALENDAR";
  PluginInterface2["CART"] = "CART";
})(PluginInterface || (PluginInterface = {}));
var ExtensionExposureExposure;
(function(ExtensionExposureExposure2) {
  ExtensionExposureExposure2["PRIVATE"] = "PRIVATE";
  ExtensionExposureExposure2["INTERNAL"] = "INTERNAL";
  ExtensionExposureExposure2["PUBLIC"] = "PUBLIC";
})(ExtensionExposureExposure || (ExtensionExposureExposure = {}));
var Maturity;
(function(Maturity2) {
  Maturity2["ALPHA"] = "ALPHA";
  Maturity2["BETA"] = "BETA";
  Maturity2["GA"] = "GA";
  Maturity2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity || (Maturity = {}));
var HTTPMethod;
(function(HTTPMethod2) {
  HTTPMethod2["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
  HTTPMethod2["GET"] = "GET";
  HTTPMethod2["POST"] = "POST";
})(HTTPMethod || (HTTPMethod = {}));
var InstallPage;
(function(InstallPage2) {
  InstallPage2["NO_PAGE"] = "NO_PAGE";
  InstallPage2["CURRENT"] = "CURRENT";
  InstallPage2["PAGE"] = "PAGE";
  InstallPage2["LIGHTBOX"] = "LIGHTBOX";
})(InstallPage || (InstallPage = {}));
var RegionType;
(function(RegionType2) {
  RegionType2["HEADER"] = "HEADER";
  RegionType2["BODY"] = "BODY";
  RegionType2["FOOTER"] = "FOOTER";
})(RegionType || (RegionType = {}));
var StaticContainer;
(function(StaticContainer2) {
  StaticContainer2["UNKNOWN_CONTAINER"] = "UNKNOWN_CONTAINER";
  StaticContainer2["HOMEPAGE"] = "HOMEPAGE";
})(StaticContainer || (StaticContainer = {}));
var EmbeddedScriptPages;
(function(EmbeddedScriptPages2) {
  EmbeddedScriptPages2["NONE_PAGES"] = "NONE_PAGES";
  EmbeddedScriptPages2["ONCE"] = "ONCE";
  EmbeddedScriptPages2["SPECIFIC_PAGES"] = "SPECIFIC_PAGES";
})(EmbeddedScriptPages || (EmbeddedScriptPages = {}));
var EmbeddedScriptPlacement;
(function(EmbeddedScriptPlacement2) {
  EmbeddedScriptPlacement2["NONE_PLACEMENT"] = "NONE_PLACEMENT";
  EmbeddedScriptPlacement2["HEAD"] = "HEAD";
  EmbeddedScriptPlacement2["BODY_START"] = "BODY_START";
  EmbeddedScriptPlacement2["BODY_END"] = "BODY_END";
})(EmbeddedScriptPlacement || (EmbeddedScriptPlacement = {}));
var EmbedCategory;
(function(EmbedCategory2) {
  EmbedCategory2["UNKNOWN"] = "UNKNOWN";
  EmbedCategory2["ESSENTIAL"] = "ESSENTIAL";
  EmbedCategory2["FUNCTIONAL"] = "FUNCTIONAL";
  EmbedCategory2["ANALYTICS"] = "ANALYTICS";
  EmbedCategory2["ADVERTISING"] = "ADVERTISING";
})(EmbedCategory || (EmbedCategory = {}));
var TemplateDefaultColor;
(function(TemplateDefaultColor2) {
  TemplateDefaultColor2["BACKGROUND"] = "BACKGROUND";
  TemplateDefaultColor2["SECONDARY_TEXTS"] = "SECONDARY_TEXTS";
  TemplateDefaultColor2["MAIN_TEXT_AND_ICONS"] = "MAIN_TEXT_AND_ICONS";
  TemplateDefaultColor2["BORDERS_AND_DIVIDERS"] = "BORDERS_AND_DIVIDERS";
  TemplateDefaultColor2["BUTTONS_AND_LINKS"] = "BUTTONS_AND_LINKS";
})(TemplateDefaultColor || (TemplateDefaultColor = {}));
var ThumbnailsSize;
(function(ThumbnailsSize2) {
  ThumbnailsSize2["SMALL"] = "SMALL";
  ThumbnailsSize2["MEDIUM"] = "MEDIUM";
  ThumbnailsSize2["LARGE"] = "LARGE";
  ThumbnailsSize2["XLARGE"] = "XLARGE";
})(ThumbnailsSize || (ThumbnailsSize = {}));
var BarAlignmentSelected;
(function(BarAlignmentSelected2) {
  BarAlignmentSelected2["ALIGN_LEFT"] = "ALIGN_LEFT";
  BarAlignmentSelected2["ALIGN_CENTER"] = "ALIGN_CENTER";
  BarAlignmentSelected2["ALIGN_RIGHT"] = "ALIGN_RIGHT";
})(BarAlignmentSelected || (BarAlignmentSelected = {}));
var DefaultTextStyle;
(function(DefaultTextStyle2) {
  DefaultTextStyle2["TITLE"] = "TITLE";
  DefaultTextStyle2["PARAGRAPH"] = "PARAGRAPH";
  DefaultTextStyle2["LOWER_HIERARCHY_TEXTS"] = "LOWER_HIERARCHY_TEXTS";
})(DefaultTextStyle || (DefaultTextStyle = {}));
var ElementType;
(function(ElementType2) {
  ElementType2["WIDGET"] = "WIDGET";
  ElementType2["PAGE"] = "PAGE";
})(ElementType || (ElementType = {}));
var ScriptType;
(function(ScriptType2) {
  ScriptType2["NO_SCRIPT_TYPE"] = "NO_SCRIPT_TYPE";
  ScriptType2["MODULE"] = "MODULE";
})(ScriptType || (ScriptType = {}));
var ExtensionType;
(function(ExtensionType2) {
  ExtensionType2["NONE_EXTENSION"] = "NONE_EXTENSION";
  ExtensionType2["PAYMENTS_GATEWAY_EXTENSION"] = "PAYMENTS_GATEWAY_EXTENSION";
  ExtensionType2["COUPONS_EXTENSION"] = "COUPONS_EXTENSION";
  ExtensionType2["DROPSHIPPING_EXTENSION"] = "DROPSHIPPING_EXTENSION";
  ExtensionType2["FULFILMENT_EXTENSION"] = "FULFILMENT_EXTENSION";
  ExtensionType2["DROPSHIPPING_SUPPLIER_EXTENSION"] = "DROPSHIPPING_SUPPLIER_EXTENSION";
  ExtensionType2["FULFILLMENT_CENTER_EXTENSION"] = "FULFILLMENT_CENTER_EXTENSION";
  ExtensionType2["RESTAURANTS_POS_EXTENSION"] = "RESTAURANTS_POS_EXTENSION";
  ExtensionType2["ART_STORE_EXTENSION"] = "ART_STORE_EXTENSION";
  ExtensionType2["ASCEND_AUTOMATION_EXTENSION"] = "ASCEND_AUTOMATION_EXTENSION";
  ExtensionType2["CONTACT_LABELS_EXTENSION"] = "CONTACT_LABELS_EXTENSION";
})(ExtensionType || (ExtensionType = {}));
var PrimitiveType;
(function(PrimitiveType2) {
  PrimitiveType2["UNKNOWN_PRIMITIVE_TYPE"] = "UNKNOWN_PRIMITIVE_TYPE";
  PrimitiveType2["TEXT"] = "TEXT";
  PrimitiveType2["BOOLEAN"] = "BOOLEAN";
  PrimitiveType2["NUMBER"] = "NUMBER";
})(PrimitiveType || (PrimitiveType = {}));
var SimpleType;
(function(SimpleType2) {
  SimpleType2["UNKNOWN_SIMPLE_TYPE"] = "UNKNOWN_SIMPLE_TYPE";
  SimpleType2["MONEY"] = "MONEY";
  SimpleType2["LINK"] = "LINK";
  SimpleType2["BACKOFFICE_LINK"] = "BACKOFFICE_LINK";
  SimpleType2["LIVESITE_LINK"] = "LIVESITE_LINK";
  SimpleType2["MULTILINGUAL"] = "MULTILINGUAL";
  SimpleType2["IMAGE_LINK"] = "IMAGE_LINK";
  SimpleType2["GUID"] = "GUID";
  SimpleType2["EMAIL"] = "EMAIL";
  SimpleType2["PHONE"] = "PHONE";
  SimpleType2["CONTACT_ID"] = "CONTACT_ID";
})(SimpleType || (SimpleType = {}));
var SchemaFieldExposure;
(function(SchemaFieldExposure2) {
  SchemaFieldExposure2["UNKNOWN_EXPOSURE"] = "UNKNOWN_EXPOSURE";
  SchemaFieldExposure2["SETUP"] = "SETUP";
  SchemaFieldExposure2["HIDDEN"] = "HIDDEN";
  SchemaFieldExposure2["EXPOSED"] = "EXPOSED";
})(SchemaFieldExposure || (SchemaFieldExposure = {}));
var PartialPaymentRestriction;
(function(PartialPaymentRestriction2) {
  PartialPaymentRestriction2["UNDEFINED"] = "UNDEFINED";
  PartialPaymentRestriction2["ALLOW"] = "ALLOW";
  PartialPaymentRestriction2["DISALLOW"] = "DISALLOW";
})(PartialPaymentRestriction || (PartialPaymentRestriction = {}));
var HostContainerId;
(function(HostContainerId2) {
  HostContainerId2["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
  HostContainerId2["BUSINESS_DASHBOARD_HOST"] = "BUSINESS_DASHBOARD_HOST";
  HostContainerId2["SIDEBAR_FOOTER"] = "SIDEBAR_FOOTER";
})(HostContainerId || (HostContainerId = {}));
var MandatoryField;
(function(MandatoryField2) {
  MandatoryField2["ZIPCODE"] = "ZIPCODE";
  MandatoryField2["CITY"] = "CITY";
  MandatoryField2["STATE"] = "STATE";
  MandatoryField2["ADDRESS"] = "ADDRESS";
  MandatoryField2["COUNTRY_CODE"] = "COUNTRY_CODE";
  MandatoryField2["EMAIL"] = "EMAIL";
  MandatoryField2["PHONE"] = "PHONE";
  MandatoryField2["FIRST_NAME"] = "FIRST_NAME";
  MandatoryField2["LAST_NAME"] = "LAST_NAME";
  MandatoryField2["STREET"] = "STREET";
  MandatoryField2["HOUSE_NUMBER"] = "HOUSE_NUMBER";
  MandatoryField2["TAX_IDENTIFIER"] = "TAX_IDENTIFIER";
})(MandatoryField || (MandatoryField = {}));
var MeasurementSystem;
(function(MeasurementSystem2) {
  MeasurementSystem2["Metric"] = "Metric";
  MeasurementSystem2["Imperial"] = "Imperial";
})(MeasurementSystem || (MeasurementSystem = {}));
var Default;
(function(Default2) {
  Default2["WIX"] = "WIX";
  Default2["POS"] = "POS";
})(Default || (Default = {}));
var HookType;
(function(HookType2) {
  HookType2["UNDEFINED"] = "UNDEFINED";
  HookType2["BEFORE_BLOCKING"] = "BEFORE_BLOCKING";
  HookType2["BEFORE"] = "BEFORE";
  HookType2["AFTER"] = "AFTER";
})(HookType || (HookType = {}));
var InterfaceConfigurationType;
(function(InterfaceConfigurationType2) {
  InterfaceConfigurationType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  InterfaceConfigurationType2["WIDGET_COMPONENT"] = "WIDGET_COMPONENT";
  InterfaceConfigurationType2["GENERIC"] = "GENERIC";
})(InterfaceConfigurationType || (InterfaceConfigurationType = {}));
var SourceType;
(function(SourceType2) {
  SourceType2["UNKNOWN_SOURCE_TYPE"] = "UNKNOWN_SOURCE_TYPE";
  SourceType2["DEV_CENTER"] = "DEV_CENTER";
  SourceType2["WIX_API"] = "WIX_API";
})(SourceType || (SourceType = {}));
var ExecutionType;
(function(ExecutionType2) {
  ExecutionType2["UNKNOWN_EXECUTION_TYPE"] = "UNKNOWN_EXECUTION_TYPE";
  ExecutionType2["SYNC"] = "SYNC";
  ExecutionType2["ASYNC"] = "ASYNC";
})(ExecutionType || (ExecutionType = {}));
var ExtendingComponentType;
(function(ExtendingComponentType2) {
  ExtendingComponentType2["INVALID"] = "INVALID";
  ExtendingComponentType2["BACK_OFFICE_MENU_ITEM"] = "BACK_OFFICE_MENU_ITEM";
  ExtendingComponentType2["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
})(ExtendingComponentType || (ExtendingComponentType = {}));
var BackOfficeHostingPlatforms;
(function(BackOfficeHostingPlatforms2) {
  BackOfficeHostingPlatforms2["NO_HOSTING_PLATFORM"] = "NO_HOSTING_PLATFORM";
  BackOfficeHostingPlatforms2["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
  BackOfficeHostingPlatforms2["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
  BackOfficeHostingPlatforms2["DEV_CENTER"] = "DEV_CENTER";
  BackOfficeHostingPlatforms2["ENTERPRISE"] = "ENTERPRISE";
  BackOfficeHostingPlatforms2["PARTNERS_DASHBOARD"] = "PARTNERS_DASHBOARD";
  BackOfficeHostingPlatforms2["FINANCIALS_INTERNAL_BO"] = "FINANCIALS_INTERNAL_BO";
  BackOfficeHostingPlatforms2["FED_GUILD_POC"] = "FED_GUILD_POC";
  BackOfficeHostingPlatforms2["STUDIO_DASHBOARD"] = "STUDIO_DASHBOARD";
  BackOfficeHostingPlatforms2["CHANNELS"] = "CHANNELS";
  BackOfficeHostingPlatforms2["DATA_TOOLS"] = "DATA_TOOLS";
  BackOfficeHostingPlatforms2["PSP_BACKOFFICE"] = "PSP_BACKOFFICE";
  BackOfficeHostingPlatforms2["RISE_PLATFORM_ACCOUNT_DASHBOARD"] = "RISE_PLATFORM_ACCOUNT_DASHBOARD";
  BackOfficeHostingPlatforms2["DEMO_DASHBOARD_ENTERPRISE"] = "DEMO_DASHBOARD_ENTERPRISE";
  BackOfficeHostingPlatforms2["AI_SCHEDULING_ASSISTANT_DASHBOARD"] = "AI_SCHEDULING_ASSISTANT_DASHBOARD";
  BackOfficeHostingPlatforms2["GETTING_PAID"] = "GETTING_PAID";
  BackOfficeHostingPlatforms2["DATA"] = "DATA";
  BackOfficeHostingPlatforms2["LITE_DASHBOARD"] = "LITE_DASHBOARD";
  BackOfficeHostingPlatforms2["PICASSO_EDITOR"] = "PICASSO_EDITOR";
  BackOfficeHostingPlatforms2["BASE44_DASHBOARD_POC"] = "BASE44_DASHBOARD_POC";
  BackOfficeHostingPlatforms2["WIXEL_EDITOR"] = "WIXEL_EDITOR";
  BackOfficeHostingPlatforms2["BASE44_PLATFORM"] = "BASE44_PLATFORM";
})(BackOfficeHostingPlatforms || (BackOfficeHostingPlatforms = {}));
var DtsDefinitionType;
(function(DtsDefinitionType2) {
  DtsDefinitionType2["UNKNOWN"] = "UNKNOWN";
  DtsDefinitionType2["DTS_HTTP_LINK"] = "DTS_HTTP_LINK";
  DtsDefinitionType2["DTS_CONTENT"] = "DTS_CONTENT";
})(DtsDefinitionType || (DtsDefinitionType = {}));
var SlotDataType;
(function(SlotDataType2) {
  SlotDataType2["UNKNOWN"] = "UNKNOWN";
  SlotDataType2["WIDGET"] = "WIDGET";
  SlotDataType2["MENU"] = "MENU";
})(SlotDataType || (SlotDataType = {}));
var BackOfficeScriptAssetType;
(function(BackOfficeScriptAssetType2) {
  BackOfficeScriptAssetType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  BackOfficeScriptAssetType2["MODULE"] = "MODULE";
})(BackOfficeScriptAssetType || (BackOfficeScriptAssetType = {}));
var ViewMode;
(function(ViewMode2) {
  ViewMode2["PAGE"] = "PAGE";
  ViewMode2["MODAL"] = "MODAL";
})(ViewMode || (ViewMode = {}));
var AlgorithmType;
(function(AlgorithmType2) {
  AlgorithmType2["UNSPECIFIED"] = "UNSPECIFIED";
  AlgorithmType2["RELATED_ITEMS"] = "RELATED_ITEMS";
  AlgorithmType2["GLOBAL"] = "GLOBAL";
})(AlgorithmType || (AlgorithmType = {}));
var LockableOperation;
(function(LockableOperation2) {
  LockableOperation2["UNSPECIFIED_LOCKABLE"] = "UNSPECIFIED_LOCKABLE";
  LockableOperation2["LOCKED"] = "LOCKED";
  LockableOperation2["UNLOCKED"] = "UNLOCKED";
})(LockableOperation || (LockableOperation = {}));
var RestrictedOperation;
(function(RestrictedOperation2) {
  RestrictedOperation2["UNSPECIFIED_RESTRICTED"] = "UNSPECIFIED_RESTRICTED";
  RestrictedOperation2["ALLOW"] = "ALLOW";
  RestrictedOperation2["WARN"] = "WARN";
})(RestrictedOperation || (RestrictedOperation = {}));
var BlockType;
(function(BlockType2) {
  BlockType2["UNKNOWN"] = "UNKNOWN";
  BlockType2["OR"] = "OR";
  BlockType2["AND"] = "AND";
})(BlockType || (BlockType = {}));
var Domain;
(function(Domain2) {
  Domain2["USER"] = "USER";
  Domain2["WIX"] = "WIX";
})(Domain || (Domain = {}));
var Status;
(function(Status2) {
  Status2["ACTIVE"] = "ACTIVE";
  Status2["INACTIVE"] = "INACTIVE";
})(Status || (Status = {}));
var LayoutMode;
(function(LayoutMode2) {
  LayoutMode2["STANDARD_VIEW"] = "STANDARD_VIEW";
  LayoutMode2["BUILDER_VIEW"] = "BUILDER_VIEW";
  LayoutMode2["EXPANDED_VIEW"] = "EXPANDED_VIEW";
})(LayoutMode || (LayoutMode = {}));
var TextInputDisplayType;
(function(TextInputDisplayType2) {
  TextInputDisplayType2["TEXT"] = "TEXT";
  TextInputDisplayType2["PASSWORD"] = "PASSWORD";
  TextInputDisplayType2["CODE"] = "CODE";
})(TextInputDisplayType || (TextInputDisplayType = {}));
var ThumbnailType;
(function(ThumbnailType2) {
  ThumbnailType2["UNKNOWN_THUMBNAIL_TYPE"] = "UNKNOWN_THUMBNAIL_TYPE";
  ThumbnailType2["IMAGE"] = "IMAGE";
  ThumbnailType2["AVATAR"] = "AVATAR";
})(ThumbnailType || (ThumbnailType = {}));
var ImageShape;
(function(ImageShape2) {
  ImageShape2["UNKNOWN_SHAPE"] = "UNKNOWN_SHAPE";
  ImageShape2["CIRCLE"] = "CIRCLE";
  ImageShape2["SQUARE"] = "SQUARE";
  ImageShape2["RECTANGLE"] = "RECTANGLE";
})(ImageShape || (ImageShape = {}));
var AvatarShape;
(function(AvatarShape2) {
  AvatarShape2["UNKNOWN_SHAPE"] = "UNKNOWN_SHAPE";
  AvatarShape2["CIRCLE"] = "CIRCLE";
  AvatarShape2["SQUARE"] = "SQUARE";
})(AvatarShape || (AvatarShape = {}));
var Tag;
(function(Tag2) {
  Tag2["UNKNOWN_TAG"] = "UNKNOWN_TAG";
  Tag2["EMBEDDABLE"] = "EMBEDDABLE";
  Tag2["ECOM_EDIT_ORDER"] = "ECOM_EDIT_ORDER";
  Tag2["ECOM_CREATE_ORDER"] = "ECOM_CREATE_ORDER";
  Tag2["INBOX"] = "INBOX";
  Tag2["ECOM_CREATE_PAY_LINK"] = "ECOM_CREATE_PAY_LINK";
  Tag2["ECOM_DELIVERY_PROFILES"] = "ECOM_DELIVERY_PROFILES";
  Tag2["ADD_TO_CATEGORY"] = "ADD_TO_CATEGORY";
  Tag2["MY_BUSINESS"] = "MY_BUSINESS";
  Tag2["PIPELINE_LINKED_ENTITY"] = "PIPELINE_LINKED_ENTITY";
  Tag2["GET_PAID"] = "GET_PAID";
  Tag2["PIPELINE_CARD_CATALOG_ITEM"] = "PIPELINE_CARD_CATALOG_ITEM";
})(Tag || (Tag = {}));
var FilterSelectionType;
(function(FilterSelectionType2) {
  FilterSelectionType2["UNKNOWN_SELECTION"] = "UNKNOWN_SELECTION";
  FilterSelectionType2["SINGLE_SELECTION"] = "SINGLE_SELECTION";
  FilterSelectionType2["MULTIPLE_SELECTION"] = "MULTIPLE_SELECTION";
})(FilterSelectionType || (FilterSelectionType = {}));
var FilterOptionsType;
(function(FilterOptionsType2) {
  FilterOptionsType2["UNKNOWN_FILTER_OPTIONS"] = "UNKNOWN_FILTER_OPTIONS";
  FilterOptionsType2["STATIC"] = "STATIC";
  FilterOptionsType2["PROVIDER"] = "PROVIDER";
})(FilterOptionsType || (FilterOptionsType = {}));
var PaginationMode;
(function(PaginationMode2) {
  PaginationMode2["UNKNOWN_PAGINATION_MODE"] = "UNKNOWN_PAGINATION_MODE";
  PaginationMode2["CURSOR"] = "CURSOR";
  PaginationMode2["OFFSET"] = "OFFSET";
})(PaginationMode || (PaginationMode = {}));
var ChannelType;
(function(ChannelType2) {
  ChannelType2["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
  ChannelType2["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
  ChannelType2["EMAIL"] = "EMAIL";
  ChannelType2["SMS"] = "SMS";
})(ChannelType || (ChannelType = {}));
var AcceptedDirectMessageType;
(function(AcceptedDirectMessageType2) {
  AcceptedDirectMessageType2["TEXT"] = "TEXT";
  AcceptedDirectMessageType2["MEDIA"] = "MEDIA";
  AcceptedDirectMessageType2["CARD"] = "CARD";
  AcceptedDirectMessageType2["ANNOUNCEMENT"] = "ANNOUNCEMENT";
  AcceptedDirectMessageType2["FORM"] = "FORM";
})(AcceptedDirectMessageType || (AcceptedDirectMessageType = {}));
var MediaMimeType;
(function(MediaMimeType2) {
  MediaMimeType2["UNKNOWN_MIME_TYPE"] = "UNKNOWN_MIME_TYPE";
  MediaMimeType2["IMAGE_JPEG"] = "IMAGE_JPEG";
  MediaMimeType2["IMAGE_PNG"] = "IMAGE_PNG";
  MediaMimeType2["IMAGE_WEBP"] = "IMAGE_WEBP";
  MediaMimeType2["VIDEO_MPEG"] = "VIDEO_MPEG";
  MediaMimeType2["VIDEO_MP4"] = "VIDEO_MP4";
  MediaMimeType2["VIDEO_3GP"] = "VIDEO_3GP";
  MediaMimeType2["AUDIO_AAC"] = "AUDIO_AAC";
  MediaMimeType2["AUDIO_MP4"] = "AUDIO_MP4";
  MediaMimeType2["AUDIO_MPEG"] = "AUDIO_MPEG";
  MediaMimeType2["AUDIO_OGG"] = "AUDIO_OGG";
  MediaMimeType2["AUDIO_OPUS"] = "AUDIO_OPUS";
  MediaMimeType2["APPLICATION_PDF"] = "APPLICATION_PDF";
  MediaMimeType2["APPLICATION_OCTET_STREAM"] = "APPLICATION_OCTET_STREAM";
})(MediaMimeType || (MediaMimeType = {}));
var AcceptedSmsMessageType;
(function(AcceptedSmsMessageType2) {
  AcceptedSmsMessageType2["SMS"] = "SMS";
  AcceptedSmsMessageType2["MMS"] = "MMS";
})(AcceptedSmsMessageType || (AcceptedSmsMessageType = {}));
var InitDirection;
(function(InitDirection2) {
  InitDirection2["UNKNOWN_INIT_DIRECTION"] = "UNKNOWN_INIT_DIRECTION";
  InitDirection2["BUSINESS"] = "BUSINESS";
  InitDirection2["CUSTOMER"] = "CUSTOMER";
  InitDirection2["BOTH"] = "BOTH";
})(InitDirection || (InitDirection = {}));
var NodeType;
(function(NodeType2) {
  NodeType2["PARAGRAPH"] = "PARAGRAPH";
  NodeType2["TEXT"] = "TEXT";
  NodeType2["HEADING"] = "HEADING";
  NodeType2["BULLETED_LIST"] = "BULLETED_LIST";
  NodeType2["ORDERED_LIST"] = "ORDERED_LIST";
  NodeType2["LIST_ITEM"] = "LIST_ITEM";
  NodeType2["BLOCKQUOTE"] = "BLOCKQUOTE";
  NodeType2["CODE_BLOCK"] = "CODE_BLOCK";
  NodeType2["VIDEO"] = "VIDEO";
  NodeType2["DIVIDER"] = "DIVIDER";
  NodeType2["FILE"] = "FILE";
  NodeType2["GALLERY"] = "GALLERY";
  NodeType2["GIF"] = "GIF";
  NodeType2["HTML"] = "HTML";
  NodeType2["IMAGE"] = "IMAGE";
  NodeType2["LINK_PREVIEW"] = "LINK_PREVIEW";
  NodeType2["MAP"] = "MAP";
  NodeType2["POLL"] = "POLL";
  NodeType2["APP_EMBED"] = "APP_EMBED";
  NodeType2["BUTTON"] = "BUTTON";
  NodeType2["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
  NodeType2["TABLE"] = "TABLE";
  NodeType2["EMBED"] = "EMBED";
  NodeType2["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
  NodeType2["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
  NodeType2["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
  NodeType2["TABLE_CELL"] = "TABLE_CELL";
  NodeType2["TABLE_ROW"] = "TABLE_ROW";
  NodeType2["EXTERNAL"] = "EXTERNAL";
  NodeType2["AUDIO"] = "AUDIO";
  NodeType2["CAPTION"] = "CAPTION";
  NodeType2["LAYOUT"] = "LAYOUT";
  NodeType2["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType || (NodeType = {}));
var WidthType;
(function(WidthType2) {
  WidthType2["CONTENT"] = "CONTENT";
  WidthType2["SMALL"] = "SMALL";
  WidthType2["ORIGINAL"] = "ORIGINAL";
  WidthType2["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
var PluginContainerDataAlignment;
(function(PluginContainerDataAlignment2) {
  PluginContainerDataAlignment2["CENTER"] = "CENTER";
  PluginContainerDataAlignment2["LEFT"] = "LEFT";
  PluginContainerDataAlignment2["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
var ButtonDataType;
(function(ButtonDataType2) {
  ButtonDataType2["LINK"] = "LINK";
  ButtonDataType2["ACTION"] = "ACTION";
})(ButtonDataType || (ButtonDataType = {}));
var LinkTarget;
(function(LinkTarget2) {
  LinkTarget2["SELF"] = "SELF";
  LinkTarget2["BLANK"] = "BLANK";
  LinkTarget2["PARENT"] = "PARENT";
  LinkTarget2["TOP"] = "TOP";
})(LinkTarget || (LinkTarget = {}));
var TextAlignment;
(function(TextAlignment2) {
  TextAlignment2["AUTO"] = "AUTO";
  TextAlignment2["LEFT"] = "LEFT";
  TextAlignment2["RIGHT"] = "RIGHT";
  TextAlignment2["CENTER"] = "CENTER";
  TextAlignment2["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
var LineStyle;
(function(LineStyle2) {
  LineStyle2["SINGLE"] = "SINGLE";
  LineStyle2["DOUBLE"] = "DOUBLE";
  LineStyle2["DASHED"] = "DASHED";
  LineStyle2["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
var DividerDataWidth;
(function(DividerDataWidth2) {
  DividerDataWidth2["LARGE"] = "LARGE";
  DividerDataWidth2["MEDIUM"] = "MEDIUM";
  DividerDataWidth2["SMALL"] = "SMALL";
})(DividerDataWidth || (DividerDataWidth = {}));
var Alignment;
(function(Alignment2) {
  Alignment2["CENTER"] = "CENTER";
  Alignment2["LEFT"] = "LEFT";
  Alignment2["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
var PDFSettingsViewMode;
(function(PDFSettingsViewMode2) {
  PDFSettingsViewMode2["NONE"] = "NONE";
  PDFSettingsViewMode2["FULL"] = "FULL";
  PDFSettingsViewMode2["MINI"] = "MINI";
})(PDFSettingsViewMode || (PDFSettingsViewMode = {}));
var LayoutType;
(function(LayoutType2) {
  LayoutType2["COLLAGE"] = "COLLAGE";
  LayoutType2["MASONRY"] = "MASONRY";
  LayoutType2["GRID"] = "GRID";
  LayoutType2["THUMBNAIL"] = "THUMBNAIL";
  LayoutType2["SLIDER"] = "SLIDER";
  LayoutType2["SLIDESHOW"] = "SLIDESHOW";
  LayoutType2["PANORAMA"] = "PANORAMA";
  LayoutType2["COLUMN"] = "COLUMN";
  LayoutType2["MAGIC"] = "MAGIC";
  LayoutType2["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
var Orientation;
(function(Orientation2) {
  Orientation2["ROWS"] = "ROWS";
  Orientation2["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
var Crop;
(function(Crop2) {
  Crop2["FILL"] = "FILL";
  Crop2["FIT"] = "FIT";
})(Crop || (Crop = {}));
var ThumbnailsAlignment;
(function(ThumbnailsAlignment2) {
  ThumbnailsAlignment2["TOP"] = "TOP";
  ThumbnailsAlignment2["RIGHT"] = "RIGHT";
  ThumbnailsAlignment2["BOTTOM"] = "BOTTOM";
  ThumbnailsAlignment2["LEFT"] = "LEFT";
  ThumbnailsAlignment2["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
var GIFType;
(function(GIFType2) {
  GIFType2["NORMAL"] = "NORMAL";
  GIFType2["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
var Source;
(function(Source2) {
  Source2["HTML"] = "HTML";
  Source2["ADSENSE"] = "ADSENSE";
  Source2["AI"] = "AI";
})(Source || (Source = {}));
var StylesPosition;
(function(StylesPosition2) {
  StylesPosition2["START"] = "START";
  StylesPosition2["END"] = "END";
  StylesPosition2["TOP"] = "TOP";
  StylesPosition2["HIDDEN"] = "HIDDEN";
})(StylesPosition || (StylesPosition = {}));
var MapType;
(function(MapType2) {
  MapType2["ROADMAP"] = "ROADMAP";
  MapType2["SATELITE"] = "SATELITE";
  MapType2["HYBRID"] = "HYBRID";
  MapType2["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
var ViewRole;
(function(ViewRole2) {
  ViewRole2["CREATOR"] = "CREATOR";
  ViewRole2["VOTERS"] = "VOTERS";
  ViewRole2["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
var VoteRole;
(function(VoteRole2) {
  VoteRole2["SITE_MEMBERS"] = "SITE_MEMBERS";
  VoteRole2["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
var PollLayoutType;
(function(PollLayoutType2) {
  PollLayoutType2["LIST"] = "LIST";
  PollLayoutType2["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
var PollLayoutDirection;
(function(PollLayoutDirection2) {
  PollLayoutDirection2["LTR"] = "LTR";
  PollLayoutDirection2["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
var BackgroundType;
(function(BackgroundType2) {
  BackgroundType2["COLOR"] = "COLOR";
  BackgroundType2["IMAGE"] = "IMAGE";
  BackgroundType2["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
var DecorationType;
(function(DecorationType2) {
  DecorationType2["BOLD"] = "BOLD";
  DecorationType2["ITALIC"] = "ITALIC";
  DecorationType2["UNDERLINE"] = "UNDERLINE";
  DecorationType2["SPOILER"] = "SPOILER";
  DecorationType2["ANCHOR"] = "ANCHOR";
  DecorationType2["MENTION"] = "MENTION";
  DecorationType2["LINK"] = "LINK";
  DecorationType2["COLOR"] = "COLOR";
  DecorationType2["FONT_SIZE"] = "FONT_SIZE";
  DecorationType2["EXTERNAL"] = "EXTERNAL";
  DecorationType2["STRIKETHROUGH"] = "STRIKETHROUGH";
  DecorationType2["SUPERSCRIPT"] = "SUPERSCRIPT";
  DecorationType2["SUBSCRIPT"] = "SUBSCRIPT";
})(DecorationType || (DecorationType = {}));
var FontType;
(function(FontType2) {
  FontType2["PX"] = "PX";
  FontType2["EM"] = "EM";
})(FontType || (FontType = {}));
var ImageStylesPosition;
(function(ImageStylesPosition2) {
  ImageStylesPosition2["START"] = "START";
  ImageStylesPosition2["END"] = "END";
  ImageStylesPosition2["TOP"] = "TOP";
})(ImageStylesPosition || (ImageStylesPosition = {}));
var AspectRatio;
(function(AspectRatio2) {
  AspectRatio2["SQUARE"] = "SQUARE";
  AspectRatio2["RECTANGLE"] = "RECTANGLE";
})(AspectRatio || (AspectRatio = {}));
var Resizing;
(function(Resizing2) {
  Resizing2["FILL"] = "FILL";
  Resizing2["FIT"] = "FIT";
})(Resizing || (Resizing = {}));
var Placement;
(function(Placement2) {
  Placement2["IMAGE"] = "IMAGE";
  Placement2["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement || (Placement = {}));
var CardStylesType;
(function(CardStylesType2) {
  CardStylesType2["CONTAINED"] = "CONTAINED";
  CardStylesType2["FRAMELESS"] = "FRAMELESS";
})(CardStylesType || (CardStylesType = {}));
var CardStylesAlignment;
(function(CardStylesAlignment2) {
  CardStylesAlignment2["START"] = "START";
  CardStylesAlignment2["CENTER"] = "CENTER";
  CardStylesAlignment2["END"] = "END";
})(CardStylesAlignment || (CardStylesAlignment = {}));
var CardStylesLayout;
(function(CardStylesLayout2) {
  CardStylesLayout2["STACKED"] = "STACKED";
  CardStylesLayout2["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout || (CardStylesLayout = {}));
var AppType;
(function(AppType2) {
  AppType2["PRODUCT"] = "PRODUCT";
  AppType2["EVENT"] = "EVENT";
  AppType2["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
var InitialExpandedItems;
(function(InitialExpandedItems2) {
  InitialExpandedItems2["FIRST"] = "FIRST";
  InitialExpandedItems2["ALL"] = "ALL";
  InitialExpandedItems2["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
var Direction;
(function(Direction2) {
  Direction2["LTR"] = "LTR";
  Direction2["RTL"] = "RTL";
})(Direction || (Direction = {}));
var VerticalAlignment;
(function(VerticalAlignment2) {
  VerticalAlignment2["TOP"] = "TOP";
  VerticalAlignment2["MIDDLE"] = "MIDDLE";
  VerticalAlignment2["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
var NullValue;
(function(NullValue2) {
  NullValue2["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
var Scaling;
(function(Scaling2) {
  Scaling2["AUTO"] = "AUTO";
  Scaling2["CONTAIN"] = "CONTAIN";
  Scaling2["COVER"] = "COVER";
})(Scaling || (Scaling = {}));
var LayoutDataImagePosition;
(function(LayoutDataImagePosition2) {
  LayoutDataImagePosition2["CENTER"] = "CENTER";
  LayoutDataImagePosition2["CENTER_LEFT"] = "CENTER_LEFT";
  LayoutDataImagePosition2["CENTER_RIGHT"] = "CENTER_RIGHT";
  LayoutDataImagePosition2["TOP"] = "TOP";
  LayoutDataImagePosition2["TOP_LEFT"] = "TOP_LEFT";
  LayoutDataImagePosition2["TOP_RIGHT"] = "TOP_RIGHT";
  LayoutDataImagePosition2["BOTTOM"] = "BOTTOM";
  LayoutDataImagePosition2["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  LayoutDataImagePosition2["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(LayoutDataImagePosition || (LayoutDataImagePosition = {}));
var VerticalAlignmentAlignment;
(function(VerticalAlignmentAlignment2) {
  VerticalAlignmentAlignment2["TOP"] = "TOP";
  VerticalAlignmentAlignment2["MIDDLE"] = "MIDDLE";
  VerticalAlignmentAlignment2["BOTTOM"] = "BOTTOM";
})(VerticalAlignmentAlignment || (VerticalAlignmentAlignment = {}));
var ResponsivenessBehaviour;
(function(ResponsivenessBehaviour2) {
  ResponsivenessBehaviour2["STACK"] = "STACK";
  ResponsivenessBehaviour2["WRAP"] = "WRAP";
})(ResponsivenessBehaviour || (ResponsivenessBehaviour = {}));
var CalendarType;
(function(CalendarType2) {
  CalendarType2["UNDEFINED"] = "UNDEFINED";
  CalendarType2["GOOGLE"] = "GOOGLE";
  CalendarType2["I_CAL"] = "I_CAL";
  CalendarType2["MICROSOFT"] = "MICROSOFT";
  CalendarType2["OTHER"] = "OTHER";
})(CalendarType || (CalendarType = {}));
var ConnectMethod;
(function(ConnectMethod2) {
  ConnectMethod2["OAUTH"] = "OAUTH";
  ConnectMethod2["CREDENTIALS"] = "CREDENTIALS";
})(ConnectMethod || (ConnectMethod = {}));
var ListEventFromCalendars;
(function(ListEventFromCalendars2) {
  ListEventFromCalendars2["LIST_NOT_SUPPORTED"] = "LIST_NOT_SUPPORTED";
  ListEventFromCalendars2["LIST_FROM_PRIMARY_CALENDAR_ONLY"] = "LIST_FROM_PRIMARY_CALENDAR_ONLY";
  ListEventFromCalendars2["LIST_FROM_SPECIFIC_CALENDARS"] = "LIST_FROM_SPECIFIC_CALENDARS";
})(ListEventFromCalendars || (ListEventFromCalendars = {}));
var SyncToCalendar;
(function(SyncToCalendar2) {
  SyncToCalendar2["SYNC_NOT_SUPPORTED"] = "SYNC_NOT_SUPPORTED";
  SyncToCalendar2["SYNC_TO_PRIMARY_CALENDAR_ONLY"] = "SYNC_TO_PRIMARY_CALENDAR_ONLY";
  SyncToCalendar2["SYNC_TO_DEDICATED_CALENDAR"] = "SYNC_TO_DEDICATED_CALENDAR";
})(SyncToCalendar || (SyncToCalendar = {}));
var OAuthAppType;
(function(OAuthAppType2) {
  OAuthAppType2["OAUTH_APP_TYPE_UNSPECIFIED"] = "OAUTH_APP_TYPE_UNSPECIFIED";
  OAuthAppType2["WEB_APP"] = "WEB_APP";
  OAuthAppType2["MOBILE"] = "MOBILE";
  OAuthAppType2["OTHER"] = "OTHER";
  OAuthAppType2["SYSTEM"] = "SYSTEM";
})(OAuthAppType || (OAuthAppType = {}));
var OAuthTechnologies;
(function(OAuthTechnologies2) {
  OAuthTechnologies2["OAUTH_TECHNOLOGY_UNSPECIFIED"] = "OAUTH_TECHNOLOGY_UNSPECIFIED";
  OAuthTechnologies2["JAVASCRIPT"] = "JAVASCRIPT";
  OAuthTechnologies2["ANGULAR"] = "ANGULAR";
  OAuthTechnologies2["VUE"] = "VUE";
  OAuthTechnologies2["REACT"] = "REACT";
  OAuthTechnologies2["REACT_NATIVE"] = "REACT_NATIVE";
  OAuthTechnologies2["IOS"] = "IOS";
  OAuthTechnologies2["ANDROID"] = "ANDROID";
  OAuthTechnologies2["OTHER_TECHNOLOGY"] = "OTHER_TECHNOLOGY";
})(OAuthTechnologies || (OAuthTechnologies = {}));
var NavigationType;
(function(NavigationType2) {
  NavigationType2["NAVIGATE"] = "NAVIGATE";
  NavigationType2["MODAL"] = "MODAL";
})(NavigationType || (NavigationType = {}));
var PingSettingsGroupComponentDataState;
(function(PingSettingsGroupComponentDataState2) {
  PingSettingsGroupComponentDataState2["UNKNOWN_STATE"] = "UNKNOWN_STATE";
  PingSettingsGroupComponentDataState2["DEFAULT_ON"] = "DEFAULT_ON";
  PingSettingsGroupComponentDataState2["DEFAULT_OFF"] = "DEFAULT_OFF";
  PingSettingsGroupComponentDataState2["ALWAYS_ON"] = "ALWAYS_ON";
})(PingSettingsGroupComponentDataState || (PingSettingsGroupComponentDataState = {}));
var State;
(function(State2) {
  State2["UNKNOWN_STATE"] = "UNKNOWN_STATE";
  State2["DEFAULT_ON"] = "DEFAULT_ON";
  State2["DEFAULT_OFF"] = "DEFAULT_OFF";
  State2["ALWAYS_ON"] = "ALWAYS_ON";
})(State || (State = {}));
var NotificationTopicType;
(function(NotificationTopicType2) {
  NotificationTopicType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  NotificationTopicType2["PROMOTIONAL"] = "PROMOTIONAL";
  NotificationTopicType2["TRANSACTIONAL"] = "TRANSACTIONAL";
})(NotificationTopicType || (NotificationTopicType = {}));
var RecipientType;
(function(RecipientType2) {
  RecipientType2["UNKNOWN_RECIPIENT_TYPE"] = "UNKNOWN_RECIPIENT_TYPE";
  RecipientType2["WIX_USER"] = "WIX_USER";
  RecipientType2["CONTACT"] = "CONTACT";
})(RecipientType || (RecipientType = {}));
var PlanFormPricingOption;
(function(PlanFormPricingOption2) {
  PlanFormPricingOption2["UNKNOWN_OPTION"] = "UNKNOWN_OPTION";
  PlanFormPricingOption2["FREE"] = "FREE";
  PlanFormPricingOption2["ONE_TIME"] = "ONE_TIME";
  PlanFormPricingOption2["RECURRING"] = "RECURRING";
})(PlanFormPricingOption || (PlanFormPricingOption = {}));
var PlanFormPricingType;
(function(PlanFormPricingType2) {
  PlanFormPricingType2["UNKNOWN_OPTION"] = "UNKNOWN_OPTION";
  PlanFormPricingType2["FREE"] = "FREE";
  PlanFormPricingType2["ONE_TIME"] = "ONE_TIME";
  PlanFormPricingType2["RECURRING"] = "RECURRING";
})(PlanFormPricingType || (PlanFormPricingType = {}));
var PlanFormDefaultSection;
(function(PlanFormDefaultSection2) {
  PlanFormDefaultSection2["UNKNWON_PLAN_FORM_SECTION"] = "UNKNWON_PLAN_FORM_SECTION";
  PlanFormDefaultSection2["INFO"] = "INFO";
  PlanFormDefaultSection2["BENEFITS"] = "BENEFITS";
  PlanFormDefaultSection2["PAGE_PERMISSIONS"] = "PAGE_PERMISSIONS";
  PlanFormDefaultSection2["PRICING_AND_DURATION"] = "PRICING_AND_DURATION";
  PlanFormDefaultSection2["ADVANCED_SETTINGS"] = "ADVANCED_SETTINGS";
  PlanFormDefaultSection2["PRICING"] = "PRICING";
  PlanFormDefaultSection2["DURATION"] = "DURATION";
})(PlanFormDefaultSection || (PlanFormDefaultSection = {}));
var PlanPeriodUnit;
(function(PlanPeriodUnit2) {
  PlanPeriodUnit2["UNDEFINED"] = "UNDEFINED";
  PlanPeriodUnit2["DAY"] = "DAY";
  PlanPeriodUnit2["WEEK"] = "WEEK";
  PlanPeriodUnit2["MONTH"] = "MONTH";
  PlanPeriodUnit2["YEAR"] = "YEAR";
})(PlanPeriodUnit || (PlanPeriodUnit = {}));
var TypedDynamicParamType;
(function(TypedDynamicParamType2) {
  TypedDynamicParamType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  TypedDynamicParamType2["STRING"] = "STRING";
  TypedDynamicParamType2["ARRAY"] = "ARRAY";
})(TypedDynamicParamType || (TypedDynamicParamType = {}));
var UserNotificationDataRecipientFilterType;
(function(UserNotificationDataRecipientFilterType2) {
  UserNotificationDataRecipientFilterType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  UserNotificationDataRecipientFilterType2["WIX_USERS"] = "WIX_USERS";
  UserNotificationDataRecipientFilterType2["SITE_CONTRIBUTORS"] = "SITE_CONTRIBUTORS";
})(UserNotificationDataRecipientFilterType || (UserNotificationDataRecipientFilterType = {}));
var InitiatorType;
(function(InitiatorType2) {
  InitiatorType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  InitiatorType2["WIX_USER"] = "WIX_USER";
  InitiatorType2["WIX_APP"] = "WIX_APP";
})(InitiatorType || (InitiatorType = {}));
var Level;
(function(Level2) {
  Level2["UNKNOWN_LEVEL"] = "UNKNOWN_LEVEL";
  Level2["ACCOUNT"] = "ACCOUNT";
  Level2["USER"] = "USER";
  Level2["SITE"] = "SITE";
})(Level || (Level = {}));
var IconType;
(function(IconType2) {
  IconType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  IconType2["URL"] = "URL";
  IconType2["SPOUT"] = "SPOUT";
  IconType2["INITIATOR"] = "INITIATOR";
})(IconType || (IconType = {}));
var MobileApplication;
(function(MobileApplication2) {
  MobileApplication2["UNKNOWN_MOBILE_APPLICATION"] = "UNKNOWN_MOBILE_APPLICATION";
  MobileApplication2["OWNER"] = "OWNER";
  MobileApplication2["SPACES"] = "SPACES";
  MobileApplication2["DINE"] = "DINE";
  MobileApplication2["FITNESS"] = "FITNESS";
  MobileApplication2["WIX_LIFE"] = "WIX_LIFE";
  MobileApplication2["WIX_PARTNERS"] = "WIX_PARTNERS";
  MobileApplication2["BRANDED"] = "BRANDED";
  MobileApplication2["WIX_STUDIO"] = "WIX_STUDIO";
  MobileApplication2["NO_SPECIFIC_TARGET_APP"] = "NO_SPECIFIC_TARGET_APP";
})(MobileApplication || (MobileApplication = {}));
var AndroidStyle;
(function(AndroidStyle2) {
  AndroidStyle2["UNKNOWN_ANDROID_STYLE"] = "UNKNOWN_ANDROID_STYLE";
  AndroidStyle2["BIG_TEXT"] = "BIG_TEXT";
  AndroidStyle2["MESSAGING"] = "MESSAGING";
  AndroidStyle2["INBOX"] = "INBOX";
})(AndroidStyle || (AndroidStyle = {}));
var ExposureRuleType;
(function(ExposureRuleType2) {
  ExposureRuleType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  ExposureRuleType2["OPEN_TO_ALL"] = "OPEN_TO_ALL";
  ExposureRuleType2["OPEN_TO_NONE"] = "OPEN_TO_NONE";
  ExposureRuleType2["BOOLEAN_EXPERIMENT"] = "BOOLEAN_EXPERIMENT";
  ExposureRuleType2["CUSTOM_EXPERIMENT"] = "CUSTOM_EXPERIMENT";
})(ExposureRuleType || (ExposureRuleType = {}));
var Intent;
(function(Intent2) {
  Intent2["UNKNOWN_INTENT"] = "UNKNOWN_INTENT";
  Intent2["MARKETING"] = "MARKETING";
  Intent2["TRANSACTIONAL"] = "TRANSACTIONAL";
})(Intent || (Intent = {}));
var UserNotificationDataType;
(function(UserNotificationDataType2) {
  UserNotificationDataType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  UserNotificationDataType2["REGULAR"] = "REGULAR";
  UserNotificationDataType2["ALERT_WARNING"] = "ALERT_WARNING";
  UserNotificationDataType2["ALERT_INFO"] = "ALERT_INFO";
})(UserNotificationDataType || (UserNotificationDataType = {}));
var RecipientFilterType;
(function(RecipientFilterType2) {
  RecipientFilterType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  RecipientFilterType2["CONTACTS"] = "CONTACTS";
})(RecipientFilterType || (RecipientFilterType = {}));
var Type;
(function(Type2) {
  Type2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  Type2["CONTACT"] = "CONTACT";
  Type2["SITE_MEMBER"] = "SITE_MEMBER";
})(Type || (Type = {}));
var Environment;
(function(Environment2) {
  Environment2["LIVE_SITE"] = "LIVE_SITE";
  Environment2["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
})(Environment || (Environment = {}));
var SchemaScope;
(function(SchemaScope2) {
  SchemaScope2["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
  SchemaScope2["GLOBAL"] = "GLOBAL";
  SchemaScope2["SITE"] = "SITE";
})(SchemaScope || (SchemaScope = {}));
var FieldType;
(function(FieldType2) {
  FieldType2["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
  FieldType2["SHORT_TEXT"] = "SHORT_TEXT";
  FieldType2["LONG_TEXT"] = "LONG_TEXT";
  FieldType2["HTML"] = "HTML";
  FieldType2["RICH_CONTENT"] = "RICH_CONTENT";
  FieldType2["IMAGE"] = "IMAGE";
  FieldType2["IMAGE_LINK"] = "IMAGE_LINK";
  FieldType2["JSON"] = "JSON";
  FieldType2["VIDEO"] = "VIDEO";
  FieldType2["DOCUMENT"] = "DOCUMENT";
})(FieldType || (FieldType = {}));
var CustomElementScriptType;
(function(CustomElementScriptType2) {
  CustomElementScriptType2["NONE"] = "NONE";
  CustomElementScriptType2["COMMON_JS"] = "COMMON_JS";
  CustomElementScriptType2["ES_MODULE"] = "ES_MODULE";
})(CustomElementScriptType || (CustomElementScriptType = {}));
var HeightMode;
(function(HeightMode2) {
  HeightMode2["UNKNOWN"] = "UNKNOWN";
  HeightMode2["AUTO"] = "AUTO";
  HeightMode2["FIXED"] = "FIXED";
})(HeightMode || (HeightMode = {}));
var FieldFieldType;
(function(FieldFieldType2) {
  FieldFieldType2["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
  FieldFieldType2["INPUT"] = "INPUT";
  FieldFieldType2["DISPLAY"] = "DISPLAY";
})(FieldFieldType || (FieldFieldType = {}));
var Format;
(function(Format2) {
  Format2["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
  Format2["DATE"] = "DATE";
  Format2["TIME"] = "TIME";
  Format2["DATE_TIME"] = "DATE_TIME";
  Format2["EMAIL"] = "EMAIL";
  Format2["URL"] = "URL";
  Format2["UUID"] = "UUID";
  Format2["PHONE"] = "PHONE";
  Format2["URI"] = "URI";
  Format2["HOSTNAME"] = "HOSTNAME";
  Format2["COLOR_HEX"] = "COLOR_HEX";
  Format2["CURRENCY"] = "CURRENCY";
  Format2["LANGUAGE"] = "LANGUAGE";
  Format2["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
var StringComponentType;
(function(StringComponentType2) {
  StringComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  StringComponentType2["TEXT_INPUT"] = "TEXT_INPUT";
  StringComponentType2["RADIO_GROUP"] = "RADIO_GROUP";
  StringComponentType2["DROPDOWN"] = "DROPDOWN";
  StringComponentType2["DATE_TIME"] = "DATE_TIME";
  StringComponentType2["PHONE_INPUT"] = "PHONE_INPUT";
  StringComponentType2["DATE_INPUT"] = "DATE_INPUT";
  StringComponentType2["TIME_INPUT"] = "TIME_INPUT";
  StringComponentType2["DATE_PICKER"] = "DATE_PICKER";
  StringComponentType2["SERVICES_DROPDOWN"] = "SERVICES_DROPDOWN";
})(StringComponentType || (StringComponentType = {}));
var ImagePosition;
(function(ImagePosition2) {
  ImagePosition2["UNKNOWN_IMAGE_POSITION"] = "UNKNOWN_IMAGE_POSITION";
  ImagePosition2["ABOVE"] = "ABOVE";
  ImagePosition2["BELOW"] = "BELOW";
})(ImagePosition || (ImagePosition = {}));
var AlignmentEnumAlignment;
(function(AlignmentEnumAlignment2) {
  AlignmentEnumAlignment2["UNKNOWN_ALIGNMENT"] = "UNKNOWN_ALIGNMENT";
  AlignmentEnumAlignment2["LEFT"] = "LEFT";
  AlignmentEnumAlignment2["CENTER"] = "CENTER";
  AlignmentEnumAlignment2["RIGHT"] = "RIGHT";
})(AlignmentEnumAlignment || (AlignmentEnumAlignment = {}));
var ImageFit;
(function(ImageFit2) {
  ImageFit2["UNKNOWN_IMAGE_FIT"] = "UNKNOWN_IMAGE_FIT";
  ImageFit2["COVER"] = "COVER";
  ImageFit2["CONTAIN"] = "CONTAIN";
})(ImageFit || (ImageFit = {}));
var NumberOfColumns;
(function(NumberOfColumns2) {
  NumberOfColumns2["UNKNOWN"] = "UNKNOWN";
  NumberOfColumns2["ZERO"] = "ZERO";
  NumberOfColumns2["ONE"] = "ONE";
  NumberOfColumns2["TWO"] = "TWO";
  NumberOfColumns2["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
var FirstDayOfWeek;
(function(FirstDayOfWeek2) {
  FirstDayOfWeek2["MONDAY"] = "MONDAY";
  FirstDayOfWeek2["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeek || (FirstDayOfWeek = {}));
var NumberComponentType;
(function(NumberComponentType2) {
  NumberComponentType2["UNKNOWN"] = "UNKNOWN";
  NumberComponentType2["NUMBER_INPUT"] = "NUMBER_INPUT";
  NumberComponentType2["RATING_INPUT"] = "RATING_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
var BooleanComponentType;
(function(BooleanComponentType2) {
  BooleanComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  BooleanComponentType2["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
var ItemType;
(function(ItemType2) {
  ItemType2["UNKNOWN_ITEM_TYPE"] = "UNKNOWN_ITEM_TYPE";
  ItemType2["STRING"] = "STRING";
  ItemType2["NUMBER"] = "NUMBER";
  ItemType2["BOOLEAN"] = "BOOLEAN";
  ItemType2["INTEGER"] = "INTEGER";
  ItemType2["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
var PropertiesTypeEnum;
(function(PropertiesTypeEnum2) {
  PropertiesTypeEnum2["UNKNOWN_PROPERTY_TYPE"] = "UNKNOWN_PROPERTY_TYPE";
  PropertiesTypeEnum2["STRING"] = "STRING";
  PropertiesTypeEnum2["NUMBER"] = "NUMBER";
  PropertiesTypeEnum2["BOOLEAN"] = "BOOLEAN";
  PropertiesTypeEnum2["INTEGER"] = "INTEGER";
  PropertiesTypeEnum2["ARRAY"] = "ARRAY";
})(PropertiesTypeEnum || (PropertiesTypeEnum = {}));
var ArrayComponentType;
(function(ArrayComponentType2) {
  ArrayComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  ArrayComponentType2["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
  ArrayComponentType2["TAGS"] = "TAGS";
})(ArrayComponentType || (ArrayComponentType = {}));
var WixFileComponentType;
(function(WixFileComponentType2) {
  WixFileComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  WixFileComponentType2["FILE_UPLOAD"] = "FILE_UPLOAD";
  WixFileComponentType2["SIGNATURE"] = "SIGNATURE";
})(WixFileComponentType || (WixFileComponentType = {}));
var UploadFileFormatEnumUploadFileFormat;
(function(UploadFileFormatEnumUploadFileFormat2) {
  UploadFileFormatEnumUploadFileFormat2["UNKNOWN_UPLOAD_FILE_FORMAT"] = "UNKNOWN_UPLOAD_FILE_FORMAT";
  UploadFileFormatEnumUploadFileFormat2["VIDEO"] = "VIDEO";
  UploadFileFormatEnumUploadFileFormat2["IMAGE"] = "IMAGE";
  UploadFileFormatEnumUploadFileFormat2["AUDIO"] = "AUDIO";
  UploadFileFormatEnumUploadFileFormat2["DOCUMENT"] = "DOCUMENT";
  UploadFileFormatEnumUploadFileFormat2["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormatEnumUploadFileFormat || (UploadFileFormatEnumUploadFileFormat = {}));
var UploadFileFormat;
(function(UploadFileFormat2) {
  UploadFileFormat2["UNDEFINED"] = "UNDEFINED";
  UploadFileFormat2["VIDEO"] = "VIDEO";
  UploadFileFormat2["IMAGE"] = "IMAGE";
  UploadFileFormat2["AUDIO"] = "AUDIO";
  UploadFileFormat2["DOCUMENT"] = "DOCUMENT";
  UploadFileFormat2["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormat || (UploadFileFormat = {}));
var PaymentComponentType;
(function(PaymentComponentType2) {
  PaymentComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  PaymentComponentType2["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
  PaymentComponentType2["DONATION_INPUT"] = "DONATION_INPUT";
  PaymentComponentType2["PAYMENT_INPUT"] = "PAYMENT_INPUT";
  PaymentComponentType2["FIXED_PAYMENT"] = "FIXED_PAYMENT";
})(PaymentComponentType || (PaymentComponentType = {}));
var ProductType;
(function(ProductType2) {
  ProductType2["UNKNOWN"] = "UNKNOWN";
  ProductType2["SHIPPABLE"] = "SHIPPABLE";
  ProductType2["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
var PriceType;
(function(PriceType2) {
  PriceType2["UNKNOWN"] = "UNKNOWN";
  PriceType2["FIXED_PRICE"] = "FIXED_PRICE";
  PriceType2["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
var AddressComponentType;
(function(AddressComponentType2) {
  AddressComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  AddressComponentType2["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(AddressComponentType || (AddressComponentType = {}));
var DefaultCountryConfigType;
(function(DefaultCountryConfigType2) {
  DefaultCountryConfigType2["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
  DefaultCountryConfigType2["BY_IP"] = "BY_IP";
  DefaultCountryConfigType2["COUNTRY"] = "COUNTRY";
})(DefaultCountryConfigType || (DefaultCountryConfigType = {}));
var SchedulingComponentType;
(function(SchedulingComponentType2) {
  SchedulingComponentType2["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
  SchedulingComponentType2["APPOINTMENT"] = "APPOINTMENT";
})(SchedulingComponentType || (SchedulingComponentType = {}));
var AppointmentFormat;
(function(AppointmentFormat2) {
  AppointmentFormat2["UNKNOWN_FORMAT_TYPE"] = "UNKNOWN_FORMAT_TYPE";
  AppointmentFormat2["IN_PERSON"] = "IN_PERSON";
  AppointmentFormat2["VIDEO_CONFERENCE"] = "VIDEO_CONFERENCE";
  AppointmentFormat2["PHONE"] = "PHONE";
})(AppointmentFormat || (AppointmentFormat = {}));
var InputType;
(function(InputType2) {
  InputType2["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
  InputType2["STRING"] = "STRING";
  InputType2["NUMBER"] = "NUMBER";
  InputType2["BOOLEAN"] = "BOOLEAN";
  InputType2["ARRAY"] = "ARRAY";
  InputType2["OBJECT"] = "OBJECT";
  InputType2["WIX_FILE"] = "WIX_FILE";
  InputType2["PAYMENT"] = "PAYMENT";
  InputType2["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
  InputType2["SCHEDULING"] = "SCHEDULING";
  InputType2["ADDRESS"] = "ADDRESS";
})(InputType || (InputType = {}));
var EmailInfoTag;
(function(EmailInfoTag2) {
  EmailInfoTag2["UNTAGGED"] = "UNTAGGED";
  EmailInfoTag2["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
var PhoneInfoTag;
(function(PhoneInfoTag2) {
  PhoneInfoTag2["UNTAGGED"] = "UNTAGGED";
  PhoneInfoTag2["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
var AddressInfoTag;
(function(AddressInfoTag2) {
  AddressInfoTag2["UNTAGGED"] = "UNTAGGED";
  AddressInfoTag2["HOME"] = "HOME";
})(AddressInfoTag || (AddressInfoTag = {}));
var ConfirmationLevel;
(function(ConfirmationLevel2) {
  ConfirmationLevel2["UNKNOWN_CONFIRMATION_LEVEL"] = "UNKNOWN_CONFIRMATION_LEVEL";
  ConfirmationLevel2["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
  ConfirmationLevel2["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(ConfirmationLevel || (ConfirmationLevel = {}));
var ContactField;
(function(ContactField2) {
  ContactField2["UNKNOWN_CONTACT_FIELD"] = "UNKNOWN_CONTACT_FIELD";
  ContactField2["FIRST_NAME"] = "FIRST_NAME";
  ContactField2["LAST_NAME"] = "LAST_NAME";
  ContactField2["COMPANY"] = "COMPANY";
  ContactField2["POSITION"] = "POSITION";
  ContactField2["EMAIL"] = "EMAIL";
  ContactField2["PHONE"] = "PHONE";
  ContactField2["ADDRESS"] = "ADDRESS";
  ContactField2["BIRTHDATE"] = "BIRTHDATE";
  ContactField2["CUSTOM_FIELD"] = "CUSTOM_FIELD";
  ContactField2["SUBSCRIPTION"] = "SUBSCRIPTION";
  ContactField2["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
var DisplayFieldType;
(function(DisplayFieldType2) {
  DisplayFieldType2["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
  DisplayFieldType2["RICH_CONTENT"] = "RICH_CONTENT";
  DisplayFieldType2["PAGE_NAVIGATION"] = "PAGE_NAVIGATION";
  DisplayFieldType2["LOGIN_BAR"] = "LOGIN_BAR";
})(DisplayFieldType || (DisplayFieldType = {}));
var ChangeableProperty;
(function(ChangeableProperty2) {
  ChangeableProperty2["UNKNOWN"] = "UNKNOWN";
  ChangeableProperty2["REQUIRED"] = "REQUIRED";
  ChangeableProperty2["HIDDEN"] = "HIDDEN";
  ChangeableProperty2["ALLOWED_VALUES"] = "ALLOWED_VALUES";
})(ChangeableProperty || (ChangeableProperty = {}));
var OverrideEntityType;
(function(OverrideEntityType2) {
  OverrideEntityType2["UNKNOWN"] = "UNKNOWN";
  OverrideEntityType2["FIELD"] = "FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
var Operator;
(function(Operator2) {
  Operator2["UNKNOWN"] = "UNKNOWN";
  Operator2["EQUAL"] = "EQUAL";
  Operator2["NOT_EQUAL"] = "NOT_EQUAL";
  Operator2["EMPTY"] = "EMPTY";
  Operator2["NOT_EMPTY"] = "NOT_EMPTY";
  Operator2["CONTAINS"] = "CONTAINS";
  Operator2["NOT_CONTAINS"] = "NOT_CONTAINS";
  Operator2["LESS_THAN"] = "LESS_THAN";
  Operator2["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
  Operator2["GREATER_THAN"] = "GREATER_THAN";
  Operator2["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
  Operator2["BEFORE"] = "BEFORE";
  Operator2["BEFORE_OR_EQUAL"] = "BEFORE_OR_EQUAL";
  Operator2["AFTER"] = "AFTER";
  Operator2["AFTER_OR_EQUAL"] = "AFTER_OR_EQUAL";
  Operator2["BETWEEN"] = "BETWEEN";
  Operator2["ANY"] = "ANY";
  Operator2["ARRAY_EQUAL"] = "ARRAY_EQUAL";
  Operator2["ARRAY_NOT_EQUAL"] = "ARRAY_NOT_EQUAL";
  Operator2["CHECKED"] = "CHECKED";
  Operator2["NOT_CHECKED"] = "NOT_CHECKED";
  Operator2["IN"] = "IN";
  Operator2["NOT_IN"] = "NOT_IN";
  Operator2["IS_DATE_OLDER_THAN"] = "IS_DATE_OLDER_THAN";
  Operator2["IS_DATE_OLDER_THAN_OR_EQUAL"] = "IS_DATE_OLDER_THAN_OR_EQUAL";
  Operator2["IS_DATE_NEWER_THAN"] = "IS_DATE_NEWER_THAN";
  Operator2["IS_DATE_NEWER_THAN_OR_EQUAL"] = "IS_DATE_NEWER_THAN_OR_EQUAL";
})(Operator || (Operator = {}));
var Target;
(function(Target2) {
  Target2["UNKNOWN_TARGET"] = "UNKNOWN_TARGET";
  Target2["SELF"] = "SELF";
  Target2["BLANK"] = "BLANK";
})(Target || (Target = {}));
var SubmitSuccessAction;
(function(SubmitSuccessAction2) {
  SubmitSuccessAction2["UNKNOWN_SUBMIT_SUCCESS_ACTION"] = "UNKNOWN_SUBMIT_SUCCESS_ACTION";
  SubmitSuccessAction2["NO_ACTION"] = "NO_ACTION";
  SubmitSuccessAction2["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
  SubmitSuccessAction2["REDIRECT"] = "REDIRECT";
})(SubmitSuccessAction || (SubmitSuccessAction = {}));
var TemplateType;
(function(TemplateType2) {
  TemplateType2["UNKNOWN"] = "UNKNOWN";
  TemplateType2["EXTENDABLE"] = "EXTENDABLE";
  TemplateType2["DEMO"] = "DEMO";
  TemplateType2["FORM_INPUT"] = "FORM_INPUT";
})(TemplateType || (TemplateType = {}));
var CustomFieldsType;
(function(CustomFieldsType2) {
  CustomFieldsType2["ANY"] = "ANY";
})(CustomFieldsType || (CustomFieldsType = {}));
var EditableProperties;
(function(EditableProperties2) {
  EditableProperties2["UNKNOWN"] = "UNKNOWN";
  EditableProperties2["REQUIRED"] = "REQUIRED";
  EditableProperties2["HIDDEN"] = "HIDDEN";
  EditableProperties2["LABEL"] = "LABEL";
  EditableProperties2["PLACEHOLDER"] = "PLACEHOLDER";
  EditableProperties2["DESCRIPTION"] = "DESCRIPTION";
  EditableProperties2["INPUT_VALUE_LIMITS"] = "INPUT_VALUE_LIMITS";
  EditableProperties2["DEFAULT_VALUE"] = "DEFAULT_VALUE";
})(EditableProperties || (EditableProperties = {}));
var RequiredIndicator;
(function(RequiredIndicator2) {
  RequiredIndicator2["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
  RequiredIndicator2["ASTERISK"] = "ASTERISK";
  RequiredIndicator2["TEXT"] = "TEXT";
  RequiredIndicator2["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
var RequiredIndicatorPlacement;
(function(RequiredIndicatorPlacement2) {
  RequiredIndicatorPlacement2["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
  RequiredIndicatorPlacement2["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
  RequiredIndicatorPlacement2["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
var WixCodePublishTaskName;
(function(WixCodePublishTaskName2) {
  WixCodePublishTaskName2["UNKNOWN"] = "UNKNOWN";
  WixCodePublishTaskName2["USER_CODE_BUNDLE"] = "USER_CODE_BUNDLE";
  WixCodePublishTaskName2["EXPORTED_FUNCTIONS_ANALYSIS"] = "EXPORTED_FUNCTIONS_ANALYSIS";
  WixCodePublishTaskName2["IMPORTED_NAMESPACES_ANALYSIS"] = "IMPORTED_NAMESPACES_ANALYSIS";
  WixCodePublishTaskName2["PAGE_DETAILS_ANALYSIS"] = "PAGE_DETAILS_ANALYSIS";
  WixCodePublishTaskName2["USER_CODE_VALIDATION"] = "USER_CODE_VALIDATION";
  WixCodePublishTaskName2["CODE_PACKAGES_REGISTRATION"] = "CODE_PACKAGES_REGISTRATION";
})(WixCodePublishTaskName || (WixCodePublishTaskName = {}));
var ChannelConfigurationChannelType;
(function(ChannelConfigurationChannelType2) {
  ChannelConfigurationChannelType2["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
  ChannelConfigurationChannelType2["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
  ChannelConfigurationChannelType2["EMAIL"] = "EMAIL";
  ChannelConfigurationChannelType2["SMS"] = "SMS";
})(ChannelConfigurationChannelType || (ChannelConfigurationChannelType = {}));
var AcceptedMessageTypesAcceptedDirectMessageType;
(function(AcceptedMessageTypesAcceptedDirectMessageType2) {
  AcceptedMessageTypesAcceptedDirectMessageType2["UNKNOWN_DIRECT_MESSAGE_TYPE"] = "UNKNOWN_DIRECT_MESSAGE_TYPE";
  AcceptedMessageTypesAcceptedDirectMessageType2["MEDIA"] = "MEDIA";
  AcceptedMessageTypesAcceptedDirectMessageType2["CARD"] = "CARD";
  AcceptedMessageTypesAcceptedDirectMessageType2["MINIMAL"] = "MINIMAL";
  AcceptedMessageTypesAcceptedDirectMessageType2["FORM"] = "FORM";
  AcceptedMessageTypesAcceptedDirectMessageType2["SYSTEM"] = "SYSTEM";
})(AcceptedMessageTypesAcceptedDirectMessageType || (AcceptedMessageTypesAcceptedDirectMessageType = {}));
var AcceptedMessageTypesAcceptedSmsMessageType;
(function(AcceptedMessageTypesAcceptedSmsMessageType2) {
  AcceptedMessageTypesAcceptedSmsMessageType2["UNKNOWN_SMS_MESSAGE_TYPE"] = "UNKNOWN_SMS_MESSAGE_TYPE";
  AcceptedMessageTypesAcceptedSmsMessageType2["SMS"] = "SMS";
  AcceptedMessageTypesAcceptedSmsMessageType2["MMS"] = "MMS";
})(AcceptedMessageTypesAcceptedSmsMessageType || (AcceptedMessageTypesAcceptedSmsMessageType = {}));
var FactorType;
(function(FactorType2) {
  FactorType2["UNKNOWN_FACTOR_TYPE"] = "UNKNOWN_FACTOR_TYPE";
  FactorType2["PASSWORD"] = "PASSWORD";
  FactorType2["SMS"] = "SMS";
  FactorType2["CALL"] = "CALL";
  FactorType2["EMAIL"] = "EMAIL";
  FactorType2["TOTP"] = "TOTP";
  FactorType2["PUSH"] = "PUSH";
  FactorType2["WEBAUTHN"] = "WEBAUTHN";
  FactorType2["RECOVERY_CODE"] = "RECOVERY_CODE";
})(FactorType || (FactorType = {}));
var MonitoringType;
(function(MonitoringType2) {
  MonitoringType2["UNKNOWN_PROVIDER"] = "UNKNOWN_PROVIDER";
  MonitoringType2["SENTRY"] = "SENTRY";
  MonitoringType2["PANORAMA"] = "PANORAMA";
})(MonitoringType || (MonitoringType = {}));
var Escalation;
(function(Escalation2) {
  Escalation2["BREAK_BUILD"] = "BREAK_BUILD";
  Escalation2["BLOCK_ROLLOUT"] = "BLOCK_ROLLOUT";
  Escalation2["BLOCK_FUTURE_ROLLOUT"] = "BLOCK_FUTURE_ROLLOUT";
  Escalation2["OPEN_BUG_SLA"] = "OPEN_BUG_SLA";
  Escalation2["VISIBILITY"] = "VISIBILITY";
})(Escalation || (Escalation = {}));
var ImportanceLevel;
(function(ImportanceLevel2) {
  ImportanceLevel2["LOW"] = "LOW";
  ImportanceLevel2["MEDIUM"] = "MEDIUM";
  ImportanceLevel2["HIGH"] = "HIGH";
})(ImportanceLevel || (ImportanceLevel = {}));
var PanelSizeWidth;
(function(PanelSizeWidth2) {
  PanelSizeWidth2["UNKNOWN_WIDTH"] = "UNKNOWN_WIDTH";
  PanelSizeWidth2["SMALL"] = "SMALL";
  PanelSizeWidth2["MEDIUM"] = "MEDIUM";
  PanelSizeWidth2["LARGE"] = "LARGE";
})(PanelSizeWidth || (PanelSizeWidth = {}));
var PanelContentType;
(function(PanelContentType2) {
  PanelContentType2["UNKNOWN_PanelContentType"] = "UNKNOWN_PanelContentType";
  PanelContentType2["url"] = "url";
  PanelContentType2["code"] = "code";
})(PanelContentType || (PanelContentType = {}));
var PanelMode;
(function(PanelMode2) {
  PanelMode2["UNKNOWN_PanelMode"] = "UNKNOWN_PanelMode";
  PanelMode2["overlay"] = "overlay";
})(PanelMode || (PanelMode = {}));
var StorageType;
(function(StorageType2) {
  StorageType2["UNKNOWN_STORAGE_TYPE"] = "UNKNOWN_STORAGE_TYPE";
  StorageType2["COOKIE"] = "COOKIE";
  StorageType2["LOCALSTORAGE"] = "LOCALSTORAGE";
  StorageType2["SESSIONSTORAGE"] = "SESSIONSTORAGE";
  StorageType2["INDEXDB"] = "INDEXDB";
})(StorageType || (StorageType = {}));
var ConsentCategory;
(function(ConsentCategory2) {
  ConsentCategory2["UNKNOWN_CATEGORY"] = "UNKNOWN_CATEGORY";
  ConsentCategory2["essential"] = "essential";
  ConsentCategory2["functional"] = "functional";
  ConsentCategory2["analytics"] = "analytics";
  ConsentCategory2["advertising"] = "advertising";
})(ConsentCategory || (ConsentCategory = {}));
var StorageDomain;
(function(StorageDomain2) {
  StorageDomain2["UNKNOWN_STORAGE_DOMAIN"] = "UNKNOWN_STORAGE_DOMAIN";
  StorageDomain2["SITE_DOMAIN"] = "SITE_DOMAIN";
  StorageDomain2["WIX_DOMAIN"] = "WIX_DOMAIN";
  StorageDomain2["APP_DOMAIN"] = "APP_DOMAIN";
})(StorageDomain || (StorageDomain = {}));
var Method;
(function(Method2) {
  Method2["CREATE"] = "CREATE";
  Method2["UPDATE"] = "UPDATE";
  Method2["CANCEL"] = "CANCEL";
})(Method || (Method = {}));
var ParticipantType;
(function(ParticipantType2) {
  ParticipantType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  ParticipantType2["WIX_USER"] = "WIX_USER";
  ParticipantType2["CONTACT"] = "CONTACT";
  ParticipantType2["ANONYMOUS"] = "ANONYMOUS";
})(ParticipantType || (ParticipantType = {}));
var V1InterfaceConfigurationType;
(function(V1InterfaceConfigurationType2) {
  V1InterfaceConfigurationType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  V1InterfaceConfigurationType2["WIDGET_COMPONENT"] = "WIDGET_COMPONENT";
  V1InterfaceConfigurationType2["ITEM_SELECTION"] = "ITEM_SELECTION";
})(V1InterfaceConfigurationType || (V1InterfaceConfigurationType = {}));
var Scope;
(function(Scope2) {
  Scope2["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
  Scope2["SPECIFIC_SITE"] = "SPECIFIC_SITE";
  Scope2["NON_SPECIFIC_SITE"] = "NON_SPECIFIC_SITE";
})(Scope || (Scope = {}));
var CssPropertyType;
(function(CssPropertyType2) {
  CssPropertyType2["UNKNOWN_CssPropertyType"] = "UNKNOWN_CssPropertyType";
  CssPropertyType2["background"] = "background";
  CssPropertyType2["backgroundSize"] = "backgroundSize";
  CssPropertyType2["backgroundColor"] = "backgroundColor";
  CssPropertyType2["backgroundImage"] = "backgroundImage";
  CssPropertyType2["backgroundClip"] = "backgroundClip";
  CssPropertyType2["backgroundOrigin"] = "backgroundOrigin";
  CssPropertyType2["backgroundPosition"] = "backgroundPosition";
  CssPropertyType2["backgroundRepeat"] = "backgroundRepeat";
  CssPropertyType2["backgroundAttachment"] = "backgroundAttachment";
  CssPropertyType2["fill"] = "fill";
  CssPropertyType2["fillOpacity"] = "fillOpacity";
  CssPropertyType2["margin"] = "margin";
  CssPropertyType2["marginTop"] = "marginTop";
  CssPropertyType2["marginRight"] = "marginRight";
  CssPropertyType2["marginBottom"] = "marginBottom";
  CssPropertyType2["marginLeft"] = "marginLeft";
  CssPropertyType2["marginInlineStart"] = "marginInlineStart";
  CssPropertyType2["marginInlineEnd"] = "marginInlineEnd";
  CssPropertyType2["padding"] = "padding";
  CssPropertyType2["paddingTop"] = "paddingTop";
  CssPropertyType2["paddingRight"] = "paddingRight";
  CssPropertyType2["paddingBottom"] = "paddingBottom";
  CssPropertyType2["paddingLeft"] = "paddingLeft";
  CssPropertyType2["paddingInlineStart"] = "paddingInlineStart";
  CssPropertyType2["paddingInlineEnd"] = "paddingInlineEnd";
  CssPropertyType2["border"] = "border";
  CssPropertyType2["borderWidth"] = "borderWidth";
  CssPropertyType2["borderStyle"] = "borderStyle";
  CssPropertyType2["borderColor"] = "borderColor";
  CssPropertyType2["borderTop"] = "borderTop";
  CssPropertyType2["borderTopColor"] = "borderTopColor";
  CssPropertyType2["borderTopWidth"] = "borderTopWidth";
  CssPropertyType2["borderTopStyle"] = "borderTopStyle";
  CssPropertyType2["borderRight"] = "borderRight";
  CssPropertyType2["borderRightColor"] = "borderRightColor";
  CssPropertyType2["borderRightWidth"] = "borderRightWidth";
  CssPropertyType2["borderRightStyle"] = "borderRightStyle";
  CssPropertyType2["borderBottom"] = "borderBottom";
  CssPropertyType2["borderBottomColor"] = "borderBottomColor";
  CssPropertyType2["borderBottomWidth"] = "borderBottomWidth";
  CssPropertyType2["borderBottomStyle"] = "borderBottomStyle";
  CssPropertyType2["borderLeft"] = "borderLeft";
  CssPropertyType2["borderLeftColor"] = "borderLeftColor";
  CssPropertyType2["borderLeftWidth"] = "borderLeftWidth";
  CssPropertyType2["borderLeftStyle"] = "borderLeftStyle";
  CssPropertyType2["borderInlineStart"] = "borderInlineStart";
  CssPropertyType2["borderInlineStartColor"] = "borderInlineStartColor";
  CssPropertyType2["borderInlineStartWidth"] = "borderInlineStartWidth";
  CssPropertyType2["borderInlineStartStyle"] = "borderInlineStartStyle";
  CssPropertyType2["borderInlineEnd"] = "borderInlineEnd";
  CssPropertyType2["borderInlineEndColor"] = "borderInlineEndColor";
  CssPropertyType2["borderInlineEndWidth"] = "borderInlineEndWidth";
  CssPropertyType2["borderInlineEndStyle"] = "borderInlineEndStyle";
  CssPropertyType2["borderRadius"] = "borderRadius";
  CssPropertyType2["borderTopLeftRadius"] = "borderTopLeftRadius";
  CssPropertyType2["borderTopRightRadius"] = "borderTopRightRadius";
  CssPropertyType2["borderBottomRightRadius"] = "borderBottomRightRadius";
  CssPropertyType2["borderBottomLeftRadius"] = "borderBottomLeftRadius";
  CssPropertyType2["borderStartStartRadius"] = "borderStartStartRadius";
  CssPropertyType2["borderStartEndRadius"] = "borderStartEndRadius";
  CssPropertyType2["borderEndStartRadius"] = "borderEndStartRadius";
  CssPropertyType2["borderEndEndRadius"] = "borderEndEndRadius";
  CssPropertyType2["font"] = "font";
  CssPropertyType2["fontFamily"] = "fontFamily";
  CssPropertyType2["fontSize"] = "fontSize";
  CssPropertyType2["fontStretch"] = "fontStretch";
  CssPropertyType2["fontStyle"] = "fontStyle";
  CssPropertyType2["fontVariant"] = "fontVariant";
  CssPropertyType2["fontWeight"] = "fontWeight";
  CssPropertyType2["lineHeight"] = "lineHeight";
  CssPropertyType2["color"] = "color";
  CssPropertyType2["letterSpacing"] = "letterSpacing";
  CssPropertyType2["writingMode"] = "writingMode";
  CssPropertyType2["textAlign"] = "textAlign";
  CssPropertyType2["textTransform"] = "textTransform";
  CssPropertyType2["textShadow"] = "textShadow";
  CssPropertyType2["textOverflow"] = "textOverflow";
  CssPropertyType2["textIndent"] = "textIndent";
  CssPropertyType2["textDecoration"] = "textDecoration";
  CssPropertyType2["textDecorationColor"] = "textDecorationColor";
  CssPropertyType2["textDecorationLine"] = "textDecorationLine";
  CssPropertyType2["textDecorationStyle"] = "textDecorationStyle";
  CssPropertyType2["textDecorationThickness"] = "textDecorationThickness";
  CssPropertyType2["boxShadow"] = "boxShadow";
  CssPropertyType2["opacity"] = "opacity";
  CssPropertyType2["overflow"] = "overflow";
  CssPropertyType2["display"] = "display";
  CssPropertyType2["alignSelf"] = "alignSelf";
  CssPropertyType2["justifyContent"] = "justifyContent";
  CssPropertyType2["alignItems"] = "alignItems";
  CssPropertyType2["flexDirection"] = "flexDirection";
  CssPropertyType2["gap"] = "gap";
  CssPropertyType2["height"] = "height";
  CssPropertyType2["width"] = "width";
  CssPropertyType2["columnGap"] = "columnGap";
  CssPropertyType2["rowGap"] = "rowGap";
  CssPropertyType2["filter"] = "filter";
  CssPropertyType2["backdropFilter"] = "backdropFilter";
  CssPropertyType2["objectFit"] = "objectFit";
  CssPropertyType2["objectPosition"] = "objectPosition";
  CssPropertyType2["mixBlendMode"] = "mixBlendMode";
  CssPropertyType2["isolation"] = "isolation";
  CssPropertyType2["stroke"] = "stroke";
  CssPropertyType2["strokeWidth"] = "strokeWidth";
  CssPropertyType2["strokeOpacity"] = "strokeOpacity";
})(CssPropertyType || (CssPropertyType = {}));
var CssDataType;
(function(CssDataType2) {
  CssDataType2["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
  CssDataType2["number"] = "number";
  CssDataType2["length"] = "length";
  CssDataType2["color"] = "color";
  CssDataType2["angle"] = "angle";
  CssDataType2["percentage"] = "percentage";
  CssDataType2["lengthPercentage"] = "lengthPercentage";
  CssDataType2["blendMode"] = "blendMode";
  CssDataType2["customEnum"] = "customEnum";
  CssDataType2["string"] = "string";
  CssDataType2["time"] = "time";
})(CssDataType || (CssDataType = {}));
var StyleType;
(function(StyleType2) {
  StyleType2["UNKNOWN_StyleType"] = "UNKNOWN_StyleType";
  StyleType2["number"] = "number";
  StyleType2["string"] = "string";
  StyleType2["angle"] = "angle";
  StyleType2["length"] = "length";
  StyleType2["percentage"] = "percentage";
  StyleType2["lengthPercentage"] = "lengthPercentage";
  StyleType2["blendMode"] = "blendMode";
  StyleType2["customEnum"] = "customEnum";
  StyleType2["time"] = "time";
  StyleType2["background"] = "background";
  StyleType2["backgroundSize"] = "backgroundSize";
  StyleType2["backgroundColor"] = "backgroundColor";
  StyleType2["backgroundImage"] = "backgroundImage";
  StyleType2["backgroundClip"] = "backgroundClip";
  StyleType2["backgroundOrigin"] = "backgroundOrigin";
  StyleType2["backgroundPosition"] = "backgroundPosition";
  StyleType2["backgroundRepeat"] = "backgroundRepeat";
  StyleType2["backgroundAttachment"] = "backgroundAttachment";
  StyleType2["margin"] = "margin";
  StyleType2["marginTop"] = "marginTop";
  StyleType2["marginRight"] = "marginRight";
  StyleType2["marginBottom"] = "marginBottom";
  StyleType2["marginLeft"] = "marginLeft";
  StyleType2["marginInlineStart"] = "marginInlineStart";
  StyleType2["marginInlineEnd"] = "marginInlineEnd";
  StyleType2["padding"] = "padding";
  StyleType2["paddingTop"] = "paddingTop";
  StyleType2["paddingRight"] = "paddingRight";
  StyleType2["paddingBottom"] = "paddingBottom";
  StyleType2["paddingLeft"] = "paddingLeft";
  StyleType2["paddingInlineStart"] = "paddingInlineStart";
  StyleType2["paddingInlineEnd"] = "paddingInlineEnd";
  StyleType2["border"] = "border";
  StyleType2["borderWidth"] = "borderWidth";
  StyleType2["borderStyle"] = "borderStyle";
  StyleType2["borderColor"] = "borderColor";
  StyleType2["borderTop"] = "borderTop";
  StyleType2["borderTopColor"] = "borderTopColor";
  StyleType2["borderTopWidth"] = "borderTopWidth";
  StyleType2["borderTopStyle"] = "borderTopStyle";
  StyleType2["borderRight"] = "borderRight";
  StyleType2["borderRightColor"] = "borderRightColor";
  StyleType2["borderRightWidth"] = "borderRightWidth";
  StyleType2["borderRightStyle"] = "borderRightStyle";
  StyleType2["borderBottom"] = "borderBottom";
  StyleType2["borderBottomColor"] = "borderBottomColor";
  StyleType2["borderBottomWidth"] = "borderBottomWidth";
  StyleType2["borderBottomStyle"] = "borderBottomStyle";
  StyleType2["borderLeft"] = "borderLeft";
  StyleType2["borderLeftColor"] = "borderLeftColor";
  StyleType2["borderLeftWidth"] = "borderLeftWidth";
  StyleType2["borderLeftStyle"] = "borderLeftStyle";
  StyleType2["borderInlineStart"] = "borderInlineStart";
  StyleType2["borderInlineStartColor"] = "borderInlineStartColor";
  StyleType2["borderInlineStartWidth"] = "borderInlineStartWidth";
  StyleType2["borderInlineStartStyle"] = "borderInlineStartStyle";
  StyleType2["borderInlineEnd"] = "borderInlineEnd";
  StyleType2["borderInlineEndColor"] = "borderInlineEndColor";
  StyleType2["borderInlineEndWidth"] = "borderInlineEndWidth";
  StyleType2["borderInlineEndStyle"] = "borderInlineEndStyle";
  StyleType2["borderRadius"] = "borderRadius";
  StyleType2["borderTopLeftRadius"] = "borderTopLeftRadius";
  StyleType2["borderTopRightRadius"] = "borderTopRightRadius";
  StyleType2["borderBottomRightRadius"] = "borderBottomRightRadius";
  StyleType2["borderBottomLeftRadius"] = "borderBottomLeftRadius";
  StyleType2["borderStartStartRadius"] = "borderStartStartRadius";
  StyleType2["borderStartEndRadius"] = "borderStartEndRadius";
  StyleType2["borderEndStartRadius"] = "borderEndStartRadius";
  StyleType2["borderEndEndRadius"] = "borderEndEndRadius";
  StyleType2["font"] = "font";
  StyleType2["fontFamily"] = "fontFamily";
  StyleType2["fontSize"] = "fontSize";
  StyleType2["fontStretch"] = "fontStretch";
  StyleType2["fontStyle"] = "fontStyle";
  StyleType2["fontVariant"] = "fontVariant";
  StyleType2["fontWeight"] = "fontWeight";
  StyleType2["lineHeight"] = "lineHeight";
  StyleType2["color"] = "color";
  StyleType2["letterSpacing"] = "letterSpacing";
  StyleType2["writingMode"] = "writingMode";
  StyleType2["textAlign"] = "textAlign";
  StyleType2["textTransform"] = "textTransform";
  StyleType2["textShadow"] = "textShadow";
  StyleType2["textOverflow"] = "textOverflow";
  StyleType2["textIndent"] = "textIndent";
  StyleType2["textDecoration"] = "textDecoration";
  StyleType2["textDecorationColor"] = "textDecorationColor";
  StyleType2["textDecorationLine"] = "textDecorationLine";
  StyleType2["textDecorationStyle"] = "textDecorationStyle";
  StyleType2["textDecorationThickness"] = "textDecorationThickness";
  StyleType2["boxShadow"] = "boxShadow";
  StyleType2["opacity"] = "opacity";
  StyleType2["overflow"] = "overflow";
  StyleType2["overflowX"] = "overflowX";
  StyleType2["overflowY"] = "overflowY";
  StyleType2["display"] = "display";
  StyleType2["alignSelf"] = "alignSelf";
  StyleType2["justifyContent"] = "justifyContent";
  StyleType2["alignItems"] = "alignItems";
  StyleType2["flexDirection"] = "flexDirection";
  StyleType2["height"] = "height";
  StyleType2["width"] = "width";
  StyleType2["gap"] = "gap";
  StyleType2["columnGap"] = "columnGap";
  StyleType2["rowGap"] = "rowGap";
  StyleType2["filter"] = "filter";
  StyleType2["backdropFilter"] = "backdropFilter";
  StyleType2["objectFit"] = "objectFit";
  StyleType2["objectPosition"] = "objectPosition";
  StyleType2["mixBlendMode"] = "mixBlendMode";
  StyleType2["isolation"] = "isolation";
  StyleType2["stroke"] = "stroke";
  StyleType2["strokeWidth"] = "strokeWidth";
  StyleType2["strokeOpacity"] = "strokeOpacity";
  StyleType2["fill"] = "fill";
  StyleType2["fillOpacity"] = "fillOpacity";
})(StyleType || (StyleType = {}));
var FilterFunction;
(function(FilterFunction2) {
  FilterFunction2["UNKNOWN_FilterFunctions"] = "UNKNOWN_FilterFunctions";
  FilterFunction2["blur"] = "blur";
  FilterFunction2["brightness"] = "brightness";
  FilterFunction2["contrast"] = "contrast";
  FilterFunction2["drop_shadow"] = "drop_shadow";
  FilterFunction2["grayscale"] = "grayscale";
  FilterFunction2["hue_rotate"] = "hue_rotate";
  FilterFunction2["invert"] = "invert";
  FilterFunction2["opacity"] = "opacity";
  FilterFunction2["sepia"] = "sepia";
  FilterFunction2["saturate"] = "saturate";
})(FilterFunction || (FilterFunction = {}));
var DisplayValueEnumDisplayValue;
(function(DisplayValueEnumDisplayValue2) {
  DisplayValueEnumDisplayValue2["UNKNOWN_DisplayValue"] = "UNKNOWN_DisplayValue";
  DisplayValueEnumDisplayValue2["none"] = "none";
  DisplayValueEnumDisplayValue2["block"] = "block";
  DisplayValueEnumDisplayValue2["inline"] = "inline";
  DisplayValueEnumDisplayValue2["flow"] = "flow";
  DisplayValueEnumDisplayValue2["flowRoot"] = "flowRoot";
  DisplayValueEnumDisplayValue2["table"] = "table";
  DisplayValueEnumDisplayValue2["flex"] = "flex";
  DisplayValueEnumDisplayValue2["grid"] = "grid";
  DisplayValueEnumDisplayValue2["list_item"] = "list_item";
  DisplayValueEnumDisplayValue2["contents"] = "contents";
  DisplayValueEnumDisplayValue2["inline_block"] = "inline_block";
  DisplayValueEnumDisplayValue2["inline_table"] = "inline_table";
  DisplayValueEnumDisplayValue2["inline_flex"] = "inline_flex";
  DisplayValueEnumDisplayValue2["inline_grid"] = "inline_grid";
})(DisplayValueEnumDisplayValue || (DisplayValueEnumDisplayValue = {}));
var WritingModeValue;
(function(WritingModeValue2) {
  WritingModeValue2["UNKNOWN_WritingModeValue"] = "UNKNOWN_WritingModeValue";
  WritingModeValue2["horizontalTb"] = "horizontalTb";
  WritingModeValue2["verticalRl"] = "verticalRl";
  WritingModeValue2["verticalLr"] = "verticalLr";
  WritingModeValue2["sidewaysRl"] = "sidewaysRl";
  WritingModeValue2["sidewaysLr"] = "sidewaysLr";
})(WritingModeValue || (WritingModeValue = {}));
var BackgroundModeEnum;
(function(BackgroundModeEnum2) {
  BackgroundModeEnum2["UNKNOWN_BackgroundModeEnum"] = "UNKNOWN_BackgroundModeEnum";
  BackgroundModeEnum2["shapeDividerSvg"] = "shapeDividerSvg";
})(BackgroundModeEnum || (BackgroundModeEnum = {}));
var ImageCategoryTypes;
(function(ImageCategoryTypes2) {
  ImageCategoryTypes2["UNKNOWN_CategoryName"] = "UNKNOWN_CategoryName";
  ImageCategoryTypes2["IMAGE"] = "IMAGE";
  ImageCategoryTypes2["IMAGE_BACKGROUND"] = "IMAGE_BACKGROUND";
})(ImageCategoryTypes || (ImageCategoryTypes = {}));
var VectorArtCategoryTypes;
(function(VectorArtCategoryTypes2) {
  VectorArtCategoryTypes2["UNKNOWN_VectorArtCategoryTypes"] = "UNKNOWN_VectorArtCategoryTypes";
  VectorArtCategoryTypes2["SHAPE_ALL"] = "SHAPE_ALL";
  VectorArtCategoryTypes2["SHAPE_BASIC"] = "SHAPE_BASIC";
  VectorArtCategoryTypes2["SHAPE_ART"] = "SHAPE_ART";
  VectorArtCategoryTypes2["ICON_SOCIAL"] = "ICON_SOCIAL";
  VectorArtCategoryTypes2["SHAPE_DIVIDERS"] = "SHAPE_DIVIDERS";
  VectorArtCategoryTypes2["SHAPE_LOCATION"] = "SHAPE_LOCATION";
  VectorArtCategoryTypes2["SHAPE_DOCUMENTS"] = "SHAPE_DOCUMENTS";
  VectorArtCategoryTypes2["SHAPE_SOCIAL"] = "SHAPE_SOCIAL";
  VectorArtCategoryTypes2["SHAPE_ARROWS"] = "SHAPE_ARROWS";
})(VectorArtCategoryTypes || (VectorArtCategoryTypes = {}));
var CssDataTypeEnumCssDataType;
(function(CssDataTypeEnumCssDataType2) {
  CssDataTypeEnumCssDataType2["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
  CssDataTypeEnumCssDataType2["number"] = "number";
  CssDataTypeEnumCssDataType2["string"] = "string";
  CssDataTypeEnumCssDataType2["angle"] = "angle";
  CssDataTypeEnumCssDataType2["color"] = "color";
  CssDataTypeEnumCssDataType2["length"] = "length";
  CssDataTypeEnumCssDataType2["percentage"] = "percentage";
  CssDataTypeEnumCssDataType2["lengthPercentage"] = "lengthPercentage";
  CssDataTypeEnumCssDataType2["blendMode"] = "blendMode";
  CssDataTypeEnumCssDataType2["customEnum"] = "customEnum";
  CssDataTypeEnumCssDataType2["time"] = "time";
})(CssDataTypeEnumCssDataType || (CssDataTypeEnumCssDataType = {}));
var DataType;
(function(DataType2) {
  DataType2["UNKNOWN_DataType"] = "UNKNOWN_DataType";
  DataType2["text"] = "text";
  DataType2["textEnum"] = "textEnum";
  DataType2["number"] = "number";
  DataType2["booleanValue"] = "booleanValue";
  DataType2["a11y"] = "a11y";
  DataType2["link"] = "link";
  DataType2["image"] = "image";
  DataType2["video"] = "video";
  DataType2["vectorArt"] = "vectorArt";
  DataType2["audio"] = "audio";
  DataType2["schema"] = "schema";
  DataType2["localDate"] = "localDate";
  DataType2["localTime"] = "localTime";
  DataType2["localDateTime"] = "localDateTime";
  DataType2["webUrl"] = "webUrl";
  DataType2["email"] = "email";
  DataType2["phone"] = "phone";
  DataType2["hostname"] = "hostname";
  DataType2["regex"] = "regex";
  DataType2["guid"] = "guid";
  DataType2["richText"] = "richText";
  DataType2["container"] = "container";
  DataType2["arrayItems"] = "arrayItems";
  DataType2["direction"] = "direction";
  DataType2["menuItems"] = "menuItems";
  DataType2["data"] = "data";
})(DataType || (DataType = {}));
var A11yAttributes;
(function(A11yAttributes2) {
  A11yAttributes2["Unknown_AriaAttributes"] = "Unknown_AriaAttributes";
  A11yAttributes2["tabIndex"] = "tabIndex";
  A11yAttributes2["ariaLevel"] = "ariaLevel";
  A11yAttributes2["ariaExpanded"] = "ariaExpanded";
  A11yAttributes2["ariaDisabled"] = "ariaDisabled";
  A11yAttributes2["ariaAtomic"] = "ariaAtomic";
  A11yAttributes2["ariaHidden"] = "ariaHidden";
  A11yAttributes2["ariaBusy"] = "ariaBusy";
  A11yAttributes2["multiline"] = "multiline";
  A11yAttributes2["ariaAutocomplete"] = "ariaAutocomplete";
  A11yAttributes2["ariaPressed"] = "ariaPressed";
  A11yAttributes2["ariaHaspopup"] = "ariaHaspopup";
  A11yAttributes2["ariaRelevant"] = "ariaRelevant";
  A11yAttributes2["role"] = "role";
  A11yAttributes2["ariaLive"] = "ariaLive";
  A11yAttributes2["ariaCurrent"] = "ariaCurrent";
  A11yAttributes2["ariaLabel"] = "ariaLabel";
  A11yAttributes2["ariaRoledescription"] = "ariaRoledescription";
  A11yAttributes2["ariaDescribedby"] = "ariaDescribedby";
  A11yAttributes2["ariaLabelledby"] = "ariaLabelledby";
  A11yAttributes2["ariaErrormessage"] = "ariaErrormessage";
  A11yAttributes2["ariaOwns"] = "ariaOwns";
  A11yAttributes2["ariaControls"] = "ariaControls";
  A11yAttributes2["tag"] = "tag";
  A11yAttributes2["ariaMultiline"] = "ariaMultiline";
  A11yAttributes2["ariaInvalid"] = "ariaInvalid";
})(A11yAttributes || (A11yAttributes = {}));
var LinkType;
(function(LinkType2) {
  LinkType2["UNKNOWN_LinkType"] = "UNKNOWN_LinkType";
  LinkType2["externalLink"] = "externalLink";
  LinkType2["anchorLink"] = "anchorLink";
  LinkType2["emailLink"] = "emailLink";
  LinkType2["phoneLink"] = "phoneLink";
  LinkType2["dynamicPageLink"] = "dynamicPageLink";
  LinkType2["pageLink"] = "pageLink";
  LinkType2["whatsAppLink"] = "whatsAppLink";
  LinkType2["documentLink"] = "documentLink";
  LinkType2["popupLink"] = "popupLink";
  LinkType2["addressLink"] = "addressLink";
  LinkType2["edgeAnchorLinks"] = "edgeAnchorLinks";
  LinkType2["loginToWixLink"] = "loginToWixLink";
})(LinkType || (LinkType = {}));
var ContainerType;
(function(ContainerType2) {
  ContainerType2["UNKNOWN_CONTAINER_TYPE"] = "UNKNOWN_CONTAINER_TYPE";
  ContainerType2["simple"] = "simple";
  ContainerType2["slot"] = "slot";
  ContainerType2["placeholder"] = "placeholder";
  ContainerType2["template"] = "template";
})(ContainerType || (ContainerType = {}));
var ResizeDirection;
(function(ResizeDirection2) {
  ResizeDirection2["UNKNOWN_ResizeDirection"] = "UNKNOWN_ResizeDirection";
  ResizeDirection2["horizontal"] = "horizontal";
  ResizeDirection2["vertical"] = "vertical";
  ResizeDirection2["horizontalAndVertical"] = "horizontalAndVertical";
  ResizeDirection2["aspectRatio"] = "aspectRatio";
  ResizeDirection2["none"] = "none";
})(ResizeDirection || (ResizeDirection = {}));
var RichTextAbilities;
(function(RichTextAbilities2) {
  RichTextAbilities2["UNKNOWN_RichTextAbilities"] = "UNKNOWN_RichTextAbilities";
  RichTextAbilities2["font"] = "font";
  RichTextAbilities2["fontFamily"] = "fontFamily";
  RichTextAbilities2["fontSize"] = "fontSize";
  RichTextAbilities2["fontStyle"] = "fontStyle";
  RichTextAbilities2["fontWeight"] = "fontWeight";
  RichTextAbilities2["textDecoration"] = "textDecoration";
  RichTextAbilities2["color"] = "color";
  RichTextAbilities2["backgroundColor"] = "backgroundColor";
  RichTextAbilities2["letterSpacing"] = "letterSpacing";
  RichTextAbilities2["textAlign"] = "textAlign";
  RichTextAbilities2["direction"] = "direction";
  RichTextAbilities2["marginStart"] = "marginStart";
  RichTextAbilities2["marginEnd"] = "marginEnd";
  RichTextAbilities2["bulletedList"] = "bulletedList";
  RichTextAbilities2["numberedList"] = "numberedList";
  RichTextAbilities2["seoTag"] = "seoTag";
})(RichTextAbilities || (RichTextAbilities = {}));
var VideoCategoryTypes;
(function(VideoCategoryTypes2) {
  VideoCategoryTypes2["UNKNOWN_VideoCategoryTypes"] = "UNKNOWN_VideoCategoryTypes";
  VideoCategoryTypes2["VIDEO"] = "VIDEO";
  VideoCategoryTypes2["VIDEO_TRANSPARENT"] = "VIDEO_TRANSPARENT";
  VideoCategoryTypes2["VIDEO_OPAQUE"] = "VIDEO_OPAQUE";
})(VideoCategoryTypes || (VideoCategoryTypes = {}));
var ElementTypeEnumElementType;
(function(ElementTypeEnumElementType2) {
  ElementTypeEnumElementType2["UNKNOWN_ElementType"] = "UNKNOWN_ElementType";
  ElementTypeEnumElementType2["inlineElement"] = "inlineElement";
  ElementTypeEnumElementType2["refElement"] = "refElement";
})(ElementTypeEnumElementType || (ElementTypeEnumElementType = {}));
var ActionType;
(function(ActionType2) {
  ActionType2["UNKNOWN_ActionType"] = "UNKNOWN_ActionType";
  ActionType2["data"] = "data";
  ActionType2["event"] = "event";
  ActionType2["panel"] = "panel";
  ActionType2["forward"] = "forward";
  ActionType2["style"] = "style";
  ActionType2["displayGroup"] = "displayGroup";
  ActionType2["cssProperty"] = "cssProperty";
  ActionType2["cssCustomProperty"] = "cssCustomProperty";
})(ActionType || (ActionType = {}));
var PanelType;
(function(PanelType2) {
  PanelType2["UNKNOWN_PanelType"] = "UNKNOWN_PanelType";
  PanelType2["panelId"] = "panelId";
  PanelType2["inline"] = "inline";
})(PanelType || (PanelType = {}));
var ActionName;
(function(ActionName2) {
  ActionName2["UNKNOWN_ActionName"] = "UNKNOWN_ActionName";
  ActionName2["settings"] = "settings";
  ActionName2["design"] = "design";
  ActionName2["media"] = "media";
  ActionName2["manageItems"] = "manageItems";
  ActionName2["dashboard"] = "dashboard";
  ActionName2["custom"] = "custom";
  ActionName2["manageMenu"] = "manageMenu";
  ActionName2["container"] = "container";
})(ActionName || (ActionName = {}));
var SizingType;
(function(SizingType2) {
  SizingType2["UNKNOWN_SizingType"] = "UNKNOWN_SizingType";
  SizingType2["content"] = "content";
  SizingType2["stretched"] = "stretched";
  SizingType2["pixels"] = "pixels";
})(SizingType || (SizingType = {}));
var BreakpointEnumBreakpoint;
(function(BreakpointEnumBreakpoint2) {
  BreakpointEnumBreakpoint2["UNKNOWN_Breakpoint"] = "UNKNOWN_Breakpoint";
  BreakpointEnumBreakpoint2["small"] = "small";
  BreakpointEnumBreakpoint2["large"] = "large";
})(BreakpointEnumBreakpoint || (BreakpointEnumBreakpoint = {}));
var ContentResizeDirection;
(function(ContentResizeDirection2) {
  ContentResizeDirection2["UNKNOWN_ContentResizeDirection"] = "UNKNOWN_ContentResizeDirection";
  ContentResizeDirection2["horizontal"] = "horizontal";
  ContentResizeDirection2["vertical"] = "vertical";
  ContentResizeDirection2["horizontalAndVertical"] = "horizontalAndVertical";
  ContentResizeDirection2["none"] = "none";
})(ContentResizeDirection || (ContentResizeDirection = {}));
var Archetype;
(function(Archetype2) {
  Archetype2["UNKNOWN_Archetype"] = "UNKNOWN_Archetype";
  Archetype2["Button"] = "Button";
  Archetype2["LoginButton"] = "LoginButton";
  Archetype2["Image"] = "Image";
  Archetype2["Gallery"] = "Gallery";
  Archetype2["Video"] = "Video";
  Archetype2["Audio"] = "Audio";
  Archetype2["Text"] = "Text";
  Archetype2["TextInput"] = "TextInput";
  Archetype2["RichTextEditor"] = "RichTextEditor";
  Archetype2["SignatureInput"] = "SignatureInput";
  Archetype2["Checkbox"] = "Checkbox";
  Archetype2["RadioGroup"] = "RadioGroup";
  Archetype2["Switch"] = "Switch";
  Archetype2["Dropdown"] = "Dropdown";
  Archetype2["DatePicker"] = "DatePicker";
  Archetype2["TimePicker"] = "TimePicker";
  Archetype2["Ratings"] = "Ratings";
  Archetype2["RatingInput"] = "RatingInput";
  Archetype2["Menu"] = "Menu";
  Archetype2["Pagination"] = "Pagination";
  Archetype2["Slider"] = "Slider";
  Archetype2["Container"] = "Container";
  Archetype2["Carousel"] = "Carousel";
  Archetype2["Accordion"] = "Accordion";
  Archetype2["Tabs"] = "Tabs";
  Archetype2["ProgressBar"] = "ProgressBar";
  Archetype2["Upload"] = "Upload";
  Archetype2["Social"] = "Social";
  Archetype2["Breadcrumbs"] = "Breadcrumbs";
  Archetype2["SearchBox"] = "SearchBox";
  Archetype2["Map"] = "Map";
  Archetype2["Line"] = "Line";
  Archetype2["Logo"] = "Logo";
  Archetype2["Avatar"] = "Avatar";
  Archetype2["Captcha"] = "Captcha";
  Archetype2["VectorArt"] = "VectorArt";
  Archetype2["AnimatedGraphic"] = "AnimatedGraphic";
  Archetype2["Cart"] = "Cart";
  Archetype2["ContactForm"] = "ContactForm";
  Archetype2["Frame"] = "Frame";
  Archetype2["Divider"] = "Divider";
})(Archetype || (Archetype = {}));
var NativeStateType;
(function(NativeStateType2) {
  NativeStateType2["UNKNOWN_NativeStateType"] = "UNKNOWN_NativeStateType";
  NativeStateType2["hover"] = "hover";
  NativeStateType2["focus"] = "focus";
  NativeStateType2["disabled"] = "disabled";
  NativeStateType2["invalid"] = "invalid";
})(NativeStateType || (NativeStateType = {}));
var GroupType;
(function(GroupType2) {
  GroupType2["UNKNOWN_GroupType"] = "UNKNOWN_GroupType";
  GroupType2["cssDataType"] = "cssDataType";
  GroupType2["dataType"] = "dataType";
  GroupType2["preset"] = "preset";
  GroupType2["data"] = "data";
  GroupType2["presets"] = "presets";
  GroupType2["cssCustomProperties"] = "cssCustomProperties";
  GroupType2["displayGroups"] = "displayGroups";
  GroupType2["background"] = "background";
  GroupType2["margin"] = "margin";
  GroupType2["padding"] = "padding";
  GroupType2["border"] = "border";
  GroupType2["borderTop"] = "borderTop";
  GroupType2["borderRight"] = "borderRight";
  GroupType2["borderBottom"] = "borderBottom";
  GroupType2["borderLeft"] = "borderLeft";
  GroupType2["borderRadius"] = "borderRadius";
  GroupType2["borderInlineStart"] = "borderInlineStart";
  GroupType2["borderInlineEnd"] = "borderInlineEnd";
  GroupType2["font"] = "font";
  GroupType2["textDecoration"] = "textDecoration";
  GroupType2["gap"] = "gap";
  GroupType2["text"] = "text";
  GroupType2["arrayItems"] = "arrayItems";
  GroupType2["arrayItem"] = "arrayItem";
  GroupType2["listItem"] = "listItem";
})(GroupType || (GroupType = {}));
var CssPropertyEnumCssPropertyType;
(function(CssPropertyEnumCssPropertyType2) {
  CssPropertyEnumCssPropertyType2["UNKNOWN_CssPropertyType"] = "UNKNOWN_CssPropertyType";
  CssPropertyEnumCssPropertyType2["number"] = "number";
  CssPropertyEnumCssPropertyType2["string"] = "string";
  CssPropertyEnumCssPropertyType2["angle"] = "angle";
  CssPropertyEnumCssPropertyType2["length"] = "length";
  CssPropertyEnumCssPropertyType2["percentage"] = "percentage";
  CssPropertyEnumCssPropertyType2["lengthPercentage"] = "lengthPercentage";
  CssPropertyEnumCssPropertyType2["blendMode"] = "blendMode";
  CssPropertyEnumCssPropertyType2["customEnum"] = "customEnum";
  CssPropertyEnumCssPropertyType2["time"] = "time";
  CssPropertyEnumCssPropertyType2["background"] = "background";
  CssPropertyEnumCssPropertyType2["backgroundSize"] = "backgroundSize";
  CssPropertyEnumCssPropertyType2["backgroundColor"] = "backgroundColor";
  CssPropertyEnumCssPropertyType2["backgroundImage"] = "backgroundImage";
  CssPropertyEnumCssPropertyType2["backgroundClip"] = "backgroundClip";
  CssPropertyEnumCssPropertyType2["backgroundOrigin"] = "backgroundOrigin";
  CssPropertyEnumCssPropertyType2["backgroundPosition"] = "backgroundPosition";
  CssPropertyEnumCssPropertyType2["backgroundRepeat"] = "backgroundRepeat";
  CssPropertyEnumCssPropertyType2["backgroundAttachment"] = "backgroundAttachment";
  CssPropertyEnumCssPropertyType2["margin"] = "margin";
  CssPropertyEnumCssPropertyType2["marginTop"] = "marginTop";
  CssPropertyEnumCssPropertyType2["marginRight"] = "marginRight";
  CssPropertyEnumCssPropertyType2["marginBottom"] = "marginBottom";
  CssPropertyEnumCssPropertyType2["marginLeft"] = "marginLeft";
  CssPropertyEnumCssPropertyType2["marginInlineStart"] = "marginInlineStart";
  CssPropertyEnumCssPropertyType2["marginInlineEnd"] = "marginInlineEnd";
  CssPropertyEnumCssPropertyType2["padding"] = "padding";
  CssPropertyEnumCssPropertyType2["paddingTop"] = "paddingTop";
  CssPropertyEnumCssPropertyType2["paddingRight"] = "paddingRight";
  CssPropertyEnumCssPropertyType2["paddingBottom"] = "paddingBottom";
  CssPropertyEnumCssPropertyType2["paddingLeft"] = "paddingLeft";
  CssPropertyEnumCssPropertyType2["paddingInlineStart"] = "paddingInlineStart";
  CssPropertyEnumCssPropertyType2["paddingInlineEnd"] = "paddingInlineEnd";
  CssPropertyEnumCssPropertyType2["border"] = "border";
  CssPropertyEnumCssPropertyType2["borderWidth"] = "borderWidth";
  CssPropertyEnumCssPropertyType2["borderStyle"] = "borderStyle";
  CssPropertyEnumCssPropertyType2["borderColor"] = "borderColor";
  CssPropertyEnumCssPropertyType2["borderTop"] = "borderTop";
  CssPropertyEnumCssPropertyType2["borderTopColor"] = "borderTopColor";
  CssPropertyEnumCssPropertyType2["borderTopWidth"] = "borderTopWidth";
  CssPropertyEnumCssPropertyType2["borderTopStyle"] = "borderTopStyle";
  CssPropertyEnumCssPropertyType2["borderRight"] = "borderRight";
  CssPropertyEnumCssPropertyType2["borderRightColor"] = "borderRightColor";
  CssPropertyEnumCssPropertyType2["borderRightWidth"] = "borderRightWidth";
  CssPropertyEnumCssPropertyType2["borderRightStyle"] = "borderRightStyle";
  CssPropertyEnumCssPropertyType2["borderBottom"] = "borderBottom";
  CssPropertyEnumCssPropertyType2["borderBottomColor"] = "borderBottomColor";
  CssPropertyEnumCssPropertyType2["borderBottomWidth"] = "borderBottomWidth";
  CssPropertyEnumCssPropertyType2["borderBottomStyle"] = "borderBottomStyle";
  CssPropertyEnumCssPropertyType2["borderLeft"] = "borderLeft";
  CssPropertyEnumCssPropertyType2["borderLeftColor"] = "borderLeftColor";
  CssPropertyEnumCssPropertyType2["borderLeftWidth"] = "borderLeftWidth";
  CssPropertyEnumCssPropertyType2["borderLeftStyle"] = "borderLeftStyle";
  CssPropertyEnumCssPropertyType2["borderInlineStart"] = "borderInlineStart";
  CssPropertyEnumCssPropertyType2["borderInlineStartColor"] = "borderInlineStartColor";
  CssPropertyEnumCssPropertyType2["borderInlineStartWidth"] = "borderInlineStartWidth";
  CssPropertyEnumCssPropertyType2["borderInlineStartStyle"] = "borderInlineStartStyle";
  CssPropertyEnumCssPropertyType2["borderInlineEnd"] = "borderInlineEnd";
  CssPropertyEnumCssPropertyType2["borderInlineEndColor"] = "borderInlineEndColor";
  CssPropertyEnumCssPropertyType2["borderInlineEndWidth"] = "borderInlineEndWidth";
  CssPropertyEnumCssPropertyType2["borderInlineEndStyle"] = "borderInlineEndStyle";
  CssPropertyEnumCssPropertyType2["borderRadius"] = "borderRadius";
  CssPropertyEnumCssPropertyType2["borderTopLeftRadius"] = "borderTopLeftRadius";
  CssPropertyEnumCssPropertyType2["borderTopRightRadius"] = "borderTopRightRadius";
  CssPropertyEnumCssPropertyType2["borderBottomRightRadius"] = "borderBottomRightRadius";
  CssPropertyEnumCssPropertyType2["borderBottomLeftRadius"] = "borderBottomLeftRadius";
  CssPropertyEnumCssPropertyType2["borderStartStartRadius"] = "borderStartStartRadius";
  CssPropertyEnumCssPropertyType2["borderStartEndRadius"] = "borderStartEndRadius";
  CssPropertyEnumCssPropertyType2["borderEndStartRadius"] = "borderEndStartRadius";
  CssPropertyEnumCssPropertyType2["borderEndEndRadius"] = "borderEndEndRadius";
  CssPropertyEnumCssPropertyType2["font"] = "font";
  CssPropertyEnumCssPropertyType2["fontFamily"] = "fontFamily";
  CssPropertyEnumCssPropertyType2["fontSize"] = "fontSize";
  CssPropertyEnumCssPropertyType2["fontStretch"] = "fontStretch";
  CssPropertyEnumCssPropertyType2["fontStyle"] = "fontStyle";
  CssPropertyEnumCssPropertyType2["fontVariant"] = "fontVariant";
  CssPropertyEnumCssPropertyType2["fontWeight"] = "fontWeight";
  CssPropertyEnumCssPropertyType2["lineHeight"] = "lineHeight";
  CssPropertyEnumCssPropertyType2["color"] = "color";
  CssPropertyEnumCssPropertyType2["letterSpacing"] = "letterSpacing";
  CssPropertyEnumCssPropertyType2["writingMode"] = "writingMode";
  CssPropertyEnumCssPropertyType2["textAlign"] = "textAlign";
  CssPropertyEnumCssPropertyType2["textTransform"] = "textTransform";
  CssPropertyEnumCssPropertyType2["textShadow"] = "textShadow";
  CssPropertyEnumCssPropertyType2["textOverflow"] = "textOverflow";
  CssPropertyEnumCssPropertyType2["textIndent"] = "textIndent";
  CssPropertyEnumCssPropertyType2["textDecoration"] = "textDecoration";
  CssPropertyEnumCssPropertyType2["textDecorationColor"] = "textDecorationColor";
  CssPropertyEnumCssPropertyType2["textDecorationLine"] = "textDecorationLine";
  CssPropertyEnumCssPropertyType2["textDecorationStyle"] = "textDecorationStyle";
  CssPropertyEnumCssPropertyType2["textDecorationThickness"] = "textDecorationThickness";
  CssPropertyEnumCssPropertyType2["boxShadow"] = "boxShadow";
  CssPropertyEnumCssPropertyType2["opacity"] = "opacity";
  CssPropertyEnumCssPropertyType2["overflow"] = "overflow";
  CssPropertyEnumCssPropertyType2["display"] = "display";
  CssPropertyEnumCssPropertyType2["alignSelf"] = "alignSelf";
  CssPropertyEnumCssPropertyType2["justifyContent"] = "justifyContent";
  CssPropertyEnumCssPropertyType2["alignItems"] = "alignItems";
  CssPropertyEnumCssPropertyType2["flexDirection"] = "flexDirection";
  CssPropertyEnumCssPropertyType2["height"] = "height";
  CssPropertyEnumCssPropertyType2["width"] = "width";
  CssPropertyEnumCssPropertyType2["gap"] = "gap";
  CssPropertyEnumCssPropertyType2["columnGap"] = "columnGap";
  CssPropertyEnumCssPropertyType2["rowGap"] = "rowGap";
  CssPropertyEnumCssPropertyType2["filter"] = "filter";
  CssPropertyEnumCssPropertyType2["backdropFilter"] = "backdropFilter";
  CssPropertyEnumCssPropertyType2["objectFit"] = "objectFit";
  CssPropertyEnumCssPropertyType2["objectPosition"] = "objectPosition";
  CssPropertyEnumCssPropertyType2["mixBlendMode"] = "mixBlendMode";
  CssPropertyEnumCssPropertyType2["isolation"] = "isolation";
  CssPropertyEnumCssPropertyType2["stroke"] = "stroke";
  CssPropertyEnumCssPropertyType2["strokeWidth"] = "strokeWidth";
  CssPropertyEnumCssPropertyType2["strokeOpacity"] = "strokeOpacity";
  CssPropertyEnumCssPropertyType2["fill"] = "fill";
  CssPropertyEnumCssPropertyType2["fillOpacity"] = "fillOpacity";
})(CssPropertyEnumCssPropertyType || (CssPropertyEnumCssPropertyType = {}));
var InteractionsTrigger;
(function(InteractionsTrigger2) {
  InteractionsTrigger2["UNKNOWN_TRIGGER"] = "UNKNOWN_TRIGGER";
  InteractionsTrigger2["hover"] = "hover";
  InteractionsTrigger2["click"] = "click";
  InteractionsTrigger2["viewEnter"] = "viewEnter";
  InteractionsTrigger2["pageVisible"] = "pageVisible";
  InteractionsTrigger2["viewProgress"] = "viewProgress";
  InteractionsTrigger2["pointerMove"] = "pointerMove";
  InteractionsTrigger2["animationEnd"] = "animationEnd";
})(InteractionsTrigger || (InteractionsTrigger = {}));
var EffectGroup;
(function(EffectGroup2) {
  EffectGroup2["UNKNOWN_EFFECT_GROUP"] = "UNKNOWN_EFFECT_GROUP";
  EffectGroup2["background"] = "background";
})(EffectGroup || (EffectGroup = {}));
var RestrictionLevel;
(function(RestrictionLevel2) {
  RestrictionLevel2["UNKNOWN_RESTRICTION_TYPE"] = "UNKNOWN_RESTRICTION_TYPE";
  RestrictionLevel2["WARNING"] = "WARNING";
  RestrictionLevel2["LOCKED"] = "LOCKED";
})(RestrictionLevel || (RestrictionLevel = {}));
var ElementDisplayOption;
(function(ElementDisplayOption2) {
  ElementDisplayOption2["UNKNOWN_OPTION"] = "UNKNOWN_OPTION";
  ElementDisplayOption2["REMOVE"] = "REMOVE";
  ElementDisplayOption2["CUSTOMIZED"] = "CUSTOMIZED";
})(ElementDisplayOption || (ElementDisplayOption = {}));
var SidebarDataType;
(function(SidebarDataType2) {
  SidebarDataType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  SidebarDataType2["CATEGORY"] = "CATEGORY";
  SidebarDataType2["PAGE"] = "PAGE";
  SidebarDataType2["SEPARATOR"] = "SEPARATOR";
})(SidebarDataType || (SidebarDataType = {}));
var SidebarEntityType;
(function(SidebarEntityType2) {
  SidebarEntityType2["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
  SidebarEntityType2["CATEGORY"] = "CATEGORY";
  SidebarEntityType2["PAGE"] = "PAGE";
  SidebarEntityType2["APP"] = "APP";
})(SidebarEntityType || (SidebarEntityType = {}));
var OperatorEnumOperator;
(function(OperatorEnumOperator2) {
  OperatorEnumOperator2["UNKNOWN_OPERATOR"] = "UNKNOWN_OPERATOR";
  OperatorEnumOperator2["EQ"] = "EQ";
  OperatorEnumOperator2["NEQ"] = "NEQ";
  OperatorEnumOperator2["GT"] = "GT";
  OperatorEnumOperator2["GTE"] = "GTE";
  OperatorEnumOperator2["LT"] = "LT";
  OperatorEnumOperator2["LTE"] = "LTE";
  OperatorEnumOperator2["BETWEEN"] = "BETWEEN";
  OperatorEnumOperator2["IN"] = "IN";
  OperatorEnumOperator2["NIN"] = "NIN";
  OperatorEnumOperator2["EMPTY"] = "EMPTY";
  OperatorEnumOperator2["NOT_EMPTY"] = "NOT_EMPTY";
  OperatorEnumOperator2["STARTS_WITH"] = "STARTS_WITH";
  OperatorEnumOperator2["HAS_ALL"] = "HAS_ALL";
  OperatorEnumOperator2["HAS_SOME"] = "HAS_SOME";
  OperatorEnumOperator2["ANY"] = "ANY";
})(OperatorEnumOperator || (OperatorEnumOperator = {}));
var ParameterType;
(function(ParameterType2) {
  ParameterType2["UNKNOWN_PARAMETER_TYPE"] = "UNKNOWN_PARAMETER_TYPE";
  ParameterType2["STRING"] = "STRING";
  ParameterType2["INT"] = "INT";
  ParameterType2["DECIMAL"] = "DECIMAL";
  ParameterType2["BOOL"] = "BOOL";
  ParameterType2["CURRENCY"] = "CURRENCY";
  ParameterType2["COUNTRY_SUBDIVISION"] = "COUNTRY_SUBDIVISION";
  ParameterType2["LANGUAGE"] = "LANGUAGE";
})(ParameterType || (ParameterType = {}));
var FilterValueDefinitionMode;
(function(FilterValueDefinitionMode2) {
  FilterValueDefinitionMode2["UNKNOWN_FILTER_VALUE_DEFINITION_MODE"] = "UNKNOWN_FILTER_VALUE_DEFINITION_MODE";
  FilterValueDefinitionMode2["ANY_VALUE_OF_SPECIFIED_TYPE"] = "ANY_VALUE_OF_SPECIFIED_TYPE";
  FilterValueDefinitionMode2["ITEM_SELECTION"] = "ITEM_SELECTION";
  FilterValueDefinitionMode2["STRING_LIST"] = "STRING_LIST";
  FilterValueDefinitionMode2["INT_LIST"] = "INT_LIST";
  FilterValueDefinitionMode2["DECIMAL_LIST"] = "DECIMAL_LIST";
  FilterValueDefinitionMode2["BOOL_LIST"] = "BOOL_LIST";
  FilterValueDefinitionMode2["CURRENCY_LIST"] = "CURRENCY_LIST";
  FilterValueDefinitionMode2["COUNTRY_SUBDIVISION_LIST"] = "COUNTRY_SUBDIVISION_LIST";
  FilterValueDefinitionMode2["LANGUAGE_TAG_LIST"] = "LANGUAGE_TAG_LIST";
})(FilterValueDefinitionMode || (FilterValueDefinitionMode = {}));
var TimeConstraintType;
(function(TimeConstraintType2) {
  TimeConstraintType2["UNKNOWN_TIME_CONSTRAINT_TYPE"] = "UNKNOWN_TIME_CONSTRAINT_TYPE";
  TimeConstraintType2["LAST_DAYS"] = "LAST_DAYS";
  TimeConstraintType2["LAST_HOURS"] = "LAST_HOURS";
  TimeConstraintType2["NEXT_DAYS"] = "NEXT_DAYS";
  TimeConstraintType2["NEXT_HOURS"] = "NEXT_HOURS";
  TimeConstraintType2["BETWEEN"] = "BETWEEN";
  TimeConstraintType2["TODAY"] = "TODAY";
  TimeConstraintType2["THIS_MONTH"] = "THIS_MONTH";
  TimeConstraintType2["AFTER"] = "AFTER";
  TimeConstraintType2["BEFORE"] = "BEFORE";
})(TimeConstraintType || (TimeConstraintType = {}));
var ValueConstraintType;
(function(ValueConstraintType2) {
  ValueConstraintType2["UNKNOWN_VALUE_CONSTRAINT_TYPE"] = "UNKNOWN_VALUE_CONSTRAINT_TYPE";
  ValueConstraintType2["NONE"] = "NONE";
  ValueConstraintType2["PREDEFINED_VALUES"] = "PREDEFINED_VALUES";
  ValueConstraintType2["MIN_MAX_RANGE"] = "MIN_MAX_RANGE";
  ValueConstraintType2["RANGE"] = "RANGE";
})(ValueConstraintType || (ValueConstraintType = {}));
var RegionScopeScope;
(function(RegionScopeScope2) {
  RegionScopeScope2["SPECIFIC_REGIONS"] = "SPECIFIC_REGIONS";
  RegionScopeScope2["WORLDWIDE"] = "WORLDWIDE";
})(RegionScopeScope || (RegionScopeScope = {}));
var VibeActionType;
(function(VibeActionType2) {
  VibeActionType2["UNKNOWN_ActionType"] = "UNKNOWN_ActionType";
  VibeActionType2["OPEN_DASHBOARD"] = "OPEN_DASHBOARD";
  VibeActionType2["OPEN_CUSTOM_PANEL"] = "OPEN_CUSTOM_PANEL";
})(VibeActionType || (VibeActionType = {}));
var AssetType;
(function(AssetType2) {
  AssetType2["UNKNOWN"] = "UNKNOWN";
  AssetType2["IMAGE"] = "IMAGE";
  AssetType2["VIDEO"] = "VIDEO";
  AssetType2["LOGO"] = "LOGO";
  AssetType2["EVENT"] = "EVENT";
  AssetType2["FORM"] = "FORM";
  AssetType2["PDF"] = "PDF";
})(AssetType || (AssetType = {}));

// src/schema/index.ts
var DATA = {
  DATA_TYPE: DataType,
  A11Y_ATTRIBUTES: A11yAttributes,
  LINK_TYPE: LinkType
};
var STYLE = {
  CSS_PROPERTY_TYPE: CssPropertyType,
  CSS_VARIABLE_TYPE: CssDataType,
  STYLE_TYPE: StyleType,
  CSS_DATA_TYPE: CssDataTypeEnumCssDataType,
  FILTER_FUNCTION: FilterFunction,
  DISPLAY_VALUE: DisplayValueEnumDisplayValue,
  WRITING_MODE_VALUE: WritingModeValue,
  BACKGROUND_MODE: BackgroundModeEnum
};
var CSS_PROPERTIES = {
  CSS_PROPERTY_TYPE: CssPropertyEnumCssPropertyType,
  FILTER_FUNCTION: FilterFunction,
  DISPLAY_VALUE: DisplayValueEnumDisplayValue,
  WRITING_MODE_VALUE: WritingModeValue,
  BACKGROUND_MODE: BackgroundModeEnum
};
var ELEMENTS = {
  ELEMENT_TYPE: ElementTypeEnumElementType
};
var ACTIONS = {
  ACTION_TYPE: ActionType,
  ACTION_NAME: ActionName,
  PANEL_TYPE: PanelType,
  PANEL_CONTENT_TYPE: PanelContentType
};
var LAYOUT = {
  RESIZE_DIRECTION: ResizeDirection,
  CONTENT_RESIZE_DIRECTION: ContentResizeDirection,
  SIZING_TYPE: SizingType,
  BREAKPOINT: BreakpointEnumBreakpoint
};
var DISPLAY_GROUPS = {
  GROUP_TYPE: GroupType
};
var INTERACTIONS = {
  TRIGGER_TYPE: InteractionsTrigger,
  EFFECT_GROUP: EffectGroup
};
var MEDIA = {
  VIDEO_CATEGORY: VideoCategoryTypes,
  VECTOR_ART_CATEGORY: VectorArtCategoryTypes,
  IMAGE_CATEGORY: ImageCategoryTypes
};
//# sourceMappingURL=index.cjs.map
